/* tslint:disable */
/* eslint-disable */
/**
 * DingAPI
 * Smart API for modern urban transportation
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@dingapi.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ApiEmailCustomPostRequest
 */
export interface ApiEmailCustomPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiEmailCustomPostRequest
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof ApiEmailCustomPostRequest
     */
    'subject': string;
    /**
     * Contenu du message (texte simple)
     * @type {string}
     * @memberof ApiEmailCustomPostRequest
     */
    'content': string;
    /**
     * Contenu HTML optionnel
     * @type {string}
     * @memberof ApiEmailCustomPostRequest
     */
    'html'?: string;
}
/**
 * 
 * @export
 * @interface ApiEmailGenericTemplatePostRequest
 */
export interface ApiEmailGenericTemplatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiEmailGenericTemplatePostRequest
     */
    'to': string;
    /**
     * Titre de l\'email
     * @type {string}
     * @memberof ApiEmailGenericTemplatePostRequest
     */
    'emailTitle': string;
    /**
     * Contenu HTML de l\'email
     * @type {string}
     * @memberof ApiEmailGenericTemplatePostRequest
     */
    'emailContent': string;
    /**
     * Sujet de l\'email (optionnel)
     * @type {string}
     * @memberof ApiEmailGenericTemplatePostRequest
     */
    'subject'?: string;
}
/**
 * 
 * @export
 * @interface ApiEmailPasswordResetPostRequest
 */
export interface ApiEmailPasswordResetPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiEmailPasswordResetPostRequest
     */
    'email': string;
    /**
     * Token de réinitialisation généré
     * @type {string}
     * @memberof ApiEmailPasswordResetPostRequest
     */
    'resetToken': string;
}
/**
 * 
 * @export
 * @interface ApiEmailRentalConfirmationPostRequest
 */
export interface ApiEmailRentalConfirmationPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiEmailRentalConfirmationPostRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiEmailRentalConfirmationPostRequest
     */
    'name': string;
    /**
     * 
     * @type {ApiEmailRentalConfirmationPostRequestRentalDetails}
     * @memberof ApiEmailRentalConfirmationPostRequest
     */
    'rentalDetails': ApiEmailRentalConfirmationPostRequestRentalDetails;
}
/**
 * 
 * @export
 * @interface ApiEmailRentalConfirmationPostRequestRentalDetails
 */
export interface ApiEmailRentalConfirmationPostRequestRentalDetails {
    /**
     * 
     * @type {string}
     * @memberof ApiEmailRentalConfirmationPostRequestRentalDetails
     */
    'vehicle_brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiEmailRentalConfirmationPostRequestRentalDetails
     */
    'vehicle_model'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiEmailRentalConfirmationPostRequestRentalDetails
     */
    'start_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiEmailRentalConfirmationPostRequestRentalDetails
     */
    'total_price'?: number;
}
/**
 * 
 * @export
 * @interface ApiEmailRequestConfirmationPostRequest
 */
export interface ApiEmailRequestConfirmationPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiEmailRequestConfirmationPostRequest
     */
    'email': string;
    /**
     * Prénom de l\'utilisateur
     * @type {string}
     * @memberof ApiEmailRequestConfirmationPostRequest
     */
    'firstname': string;
}
/**
 * 
 * @export
 * @interface ApiEmailTestPostRequest
 */
export interface ApiEmailTestPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiEmailTestPostRequest
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof ApiEmailTestPostRequest
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof ApiEmailTestPostRequest
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof ApiEmailTestPostRequest
     */
    'html'?: string;
}
/**
 * 
 * @export
 * @interface ApiEmailWelcomePostRequest
 */
export interface ApiEmailWelcomePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiEmailWelcomePostRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiEmailWelcomePostRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ApiPasswordResetRequestPost200Response
 */
export interface ApiPasswordResetRequestPost200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ApiPasswordResetRequestPost200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiPasswordResetRequestPost200Response
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiPasswordResetRequestPost200Response
     */
    'expiresIn'?: string;
}
/**
 * 
 * @export
 * @interface ApiPasswordResetRequestPost400Response
 */
export interface ApiPasswordResetRequestPost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiPasswordResetRequestPost400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ApiPasswordResetRequestPost404Response
 */
export interface ApiPasswordResetRequestPost404Response {
    /**
     * 
     * @type {string}
     * @memberof ApiPasswordResetRequestPost404Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ApiPasswordResetRequestPostRequest
 */
export interface ApiPasswordResetRequestPostRequest {
    /**
     * Adresse email de l\'utilisateur
     * @type {string}
     * @memberof ApiPasswordResetRequestPostRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ApiPasswordResetResetPost200Response
 */
export interface ApiPasswordResetResetPost200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ApiPasswordResetResetPost200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiPasswordResetResetPost200Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiPasswordResetResetPost400Response
 */
export interface ApiPasswordResetResetPost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiPasswordResetResetPost400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ApiPasswordResetResetPostRequest
 */
export interface ApiPasswordResetResetPostRequest {
    /**
     * Adresse email de l\'utilisateur
     * @type {string}
     * @memberof ApiPasswordResetResetPostRequest
     */
    'email': string;
    /**
     * Code de réinitialisation vérifié
     * @type {string}
     * @memberof ApiPasswordResetResetPostRequest
     */
    'code': string;
    /**
     * Nouveau mot de passe (minimum 6 caractères)
     * @type {string}
     * @memberof ApiPasswordResetResetPostRequest
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ApiPasswordResetVerifyPost200Response
 */
export interface ApiPasswordResetVerifyPost200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ApiPasswordResetVerifyPost200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiPasswordResetVerifyPost200Response
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiPasswordResetVerifyPost200Response
     */
    'canResetPassword'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiPasswordResetVerifyPost400Response
 */
export interface ApiPasswordResetVerifyPost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiPasswordResetVerifyPost400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ApiPasswordResetVerifyPostRequest
 */
export interface ApiPasswordResetVerifyPostRequest {
    /**
     * Adresse email de l\'utilisateur
     * @type {string}
     * @memberof ApiPasswordResetVerifyPostRequest
     */
    'email': string;
    /**
     * Code de réinitialisation au format XXX-XXX
     * @type {string}
     * @memberof ApiPasswordResetVerifyPostRequest
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface ApiRentalsCountGet200Response
 */
export interface ApiRentalsCountGet200Response {
    /**
     * Nombre de locations
     * @type {number}
     * @memberof ApiRentalsCountGet200Response
     */
    'count'?: number;
    /**
     * ID de l\'utilisateur
     * @type {string}
     * @memberof ApiRentalsCountGet200Response
     */
    'user_id'?: string;
    /**
     * Type d\'utilisateur (locataire ou propriétaire)
     * @type {string}
     * @memberof ApiRentalsCountGet200Response
     */
    'user_type'?: ApiRentalsCountGet200ResponseUserTypeEnum;
}

export const ApiRentalsCountGet200ResponseUserTypeEnum = {
    Renter: 'renter',
    Owner: 'owner'
} as const;

export type ApiRentalsCountGet200ResponseUserTypeEnum = typeof ApiRentalsCountGet200ResponseUserTypeEnum[keyof typeof ApiRentalsCountGet200ResponseUserTypeEnum];

/**
 * 
 * @export
 * @interface ApiRentalsIdPutRequest
 */
export interface ApiRentalsIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiRentalsIdPutRequest
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiRentalsIdPutRequest
     */
    'status'?: ApiRentalsIdPutRequestStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ApiRentalsIdPutRequest
     */
    'total_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiRentalsIdPutRequest
     */
    'promo_code_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiRentalsIdPutRequest
     */
    'discount_applied'?: number;
    /**
     * Type de véhicule (ex: voiture, moto, scooter)
     * @type {string}
     * @memberof ApiRentalsIdPutRequest
     */
    'vehicle_type'?: string;
    /**
     * Nombre de kilomètres au début de la location
     * @type {number}
     * @memberof ApiRentalsIdPutRequest
     */
    'nb_kilometre'?: number;
    /**
     * Lieu de départ de la location
     * @type {string}
     * @memberof ApiRentalsIdPutRequest
     */
    'lieu_start'?: string;
}

export const ApiRentalsIdPutRequestStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;

export type ApiRentalsIdPutRequestStatusEnum = typeof ApiRentalsIdPutRequestStatusEnum[keyof typeof ApiRentalsIdPutRequestStatusEnum];

/**
 * 
 * @export
 * @interface ApiRentalsPostRequest
 */
export interface ApiRentalsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiRentalsPostRequest
     */
    'vehicle_id': string;
    /**
     * 
     * @type {string}
     * @memberof ApiRentalsPostRequest
     */
    'renter_id': string;
    /**
     * 
     * @type {string}
     * @memberof ApiRentalsPostRequest
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof ApiRentalsPostRequest
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiRentalsPostRequest
     */
    'status'?: ApiRentalsPostRequestStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ApiRentalsPostRequest
     */
    'total_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiRentalsPostRequest
     */
    'source'?: ApiRentalsPostRequestSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiRentalsPostRequest
     */
    'owner_id': string;
    /**
     * 
     * @type {string}
     * @memberof ApiRentalsPostRequest
     */
    'promo_code_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiRentalsPostRequest
     */
    'discount_applied'?: number;
    /**
     * Type de véhicule (ex: voiture, moto, scooter)
     * @type {string}
     * @memberof ApiRentalsPostRequest
     */
    'vehicle_type'?: string;
    /**
     * Nombre de kilomètres au début de la location
     * @type {number}
     * @memberof ApiRentalsPostRequest
     */
    'nb_kilometre'?: number;
    /**
     * Lieu de départ de la location
     * @type {string}
     * @memberof ApiRentalsPostRequest
     */
    'lieu_start'?: string;
}

export const ApiRentalsPostRequestStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;

export type ApiRentalsPostRequestStatusEnum = typeof ApiRentalsPostRequestStatusEnum[keyof typeof ApiRentalsPostRequestStatusEnum];
export const ApiRentalsPostRequestSourceEnum = {
    App: 'app',
    Web: 'web',
    Api: 'api'
} as const;

export type ApiRentalsPostRequestSourceEnum = typeof ApiRentalsPostRequestSourceEnum[keyof typeof ApiRentalsPostRequestSourceEnum];

/**
 * 
 * @export
 * @interface ApiUsersIdChangePasswordPostRequest
 */
export interface ApiUsersIdChangePasswordPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdChangePasswordPostRequest
     */
    'oldPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdChangePasswordPostRequest
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ApiUsersIdDelete200Response
 */
export interface ApiUsersIdDelete200Response {
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdDelete200Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiUsersIdPutRequest
 */
export interface ApiUsersIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdPutRequest
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdPutRequest
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdPutRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdPutRequest
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdPutRequest
     */
    'birth_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdPutRequest
     */
    'profile_photo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdPutRequest
     */
    'role'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiUsersIdPutRequest
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiUsersIdPutRequest
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiUsersIdPutRequest
     */
    'average_rating'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiUsersIdPutRequest
     */
    'total_reviews'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdPutRequest
     */
    'registration_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdPutRequest
     */
    'last_login'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdPutRequest
     */
    'license_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiUsersIdPutRequest
     */
    'contract_accepted'?: boolean;
    /**
     * Indique si l\'utilisateur a été vérifié/validé
     * @type {boolean}
     * @memberof ApiUsersIdPutRequest
     */
    'is_checked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersIdPutRequest
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface ApiUsersLoginPost200Response
 */
export interface ApiUsersLoginPost200Response {
    /**
     * 
     * @type {string}
     * @memberof ApiUsersLoginPost200Response
     */
    'token'?: string;
    /**
     * 
     * @type {User}
     * @memberof ApiUsersLoginPost200Response
     */
    'user'?: User;
}
/**
 * 
 * @export
 * @interface ApiUsersLoginPostRequest
 */
export interface ApiUsersLoginPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiUsersLoginPostRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersLoginPostRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ApiUsersRegisterPostRequest
 */
export interface ApiUsersRegisterPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiUsersRegisterPostRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersRegisterPostRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersRegisterPostRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersRegisterPostRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ApiUsersRequestPasswordResetPostRequest
 */
export interface ApiUsersRequestPasswordResetPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiUsersRequestPasswordResetPostRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ApiUsersResetPasswordPostRequest
 */
export interface ApiUsersResetPasswordPostRequest {
    /**
     * Token de réinitialisation reçu par email
     * @type {string}
     * @memberof ApiUsersResetPasswordPostRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof ApiUsersResetPasswordPostRequest
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ApiVehiclesCountGet200Response
 */
export interface ApiVehiclesCountGet200Response {
    /**
     * Nombre de véhicules
     * @type {number}
     * @memberof ApiVehiclesCountGet200Response
     */
    'count'?: number;
    /**
     * ID de l\'utilisateur
     * @type {string}
     * @memberof ApiVehiclesCountGet200Response
     */
    'owner_id'?: string;
}
/**
 * 
 * @export
 * @interface ApiVehiclesIdPutRequest
 */
export interface ApiVehiclesIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiVehiclesIdPutRequest
     */
    'serial_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiVehiclesIdPutRequest
     */
    'vehicle_type'?: ApiVehiclesIdPutRequestVehicleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiVehiclesIdPutRequest
     */
    'brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiVehiclesIdPutRequest
     */
    'model'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiVehiclesIdPutRequest
     */
    'year'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ApiVehiclesIdPutRequest
     */
    'is_platform_owned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiVehiclesIdPutRequest
     */
    'is_available'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiVehiclesIdPutRequest
     */
    'hourly_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiVehiclesIdPutRequest
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiVehiclesIdPutRequest
     */
    'longitude'?: number;
}

export const ApiVehiclesIdPutRequestVehicleTypeEnum = {
    Scooter: 'scooter',
    Bike: 'bike',
    Car: 'car',
    Motorcycle: 'motorcycle'
} as const;

export type ApiVehiclesIdPutRequestVehicleTypeEnum = typeof ApiVehiclesIdPutRequestVehicleTypeEnum[keyof typeof ApiVehiclesIdPutRequestVehicleTypeEnum];

/**
 * 
 * @export
 * @interface ApiVehiclesPostRequest
 */
export interface ApiVehiclesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiVehiclesPostRequest
     */
    'serial_number': string;
    /**
     * 
     * @type {string}
     * @memberof ApiVehiclesPostRequest
     */
    'vehicle_type': ApiVehiclesPostRequestVehicleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiVehiclesPostRequest
     */
    'brand': string;
    /**
     * 
     * @type {string}
     * @memberof ApiVehiclesPostRequest
     */
    'model': string;
    /**
     * 
     * @type {number}
     * @memberof ApiVehiclesPostRequest
     */
    'year': number;
    /**
     * 
     * @type {string}
     * @memberof ApiVehiclesPostRequest
     */
    'owner_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiVehiclesPostRequest
     */
    'is_platform_owned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiVehiclesPostRequest
     */
    'is_available'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiVehiclesPostRequest
     */
    'hourly_rate': number;
    /**
     * 
     * @type {number}
     * @memberof ApiVehiclesPostRequest
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiVehiclesPostRequest
     */
    'longitude'?: number;
}

export const ApiVehiclesPostRequestVehicleTypeEnum = {
    Scooter: 'scooter',
    Bike: 'bike',
    Car: 'car',
    Motorcycle: 'motorcycle'
} as const;

export type ApiVehiclesPostRequestVehicleTypeEnum = typeof ApiVehiclesPostRequestVehicleTypeEnum[keyof typeof ApiVehiclesPostRequestVehicleTypeEnum];

/**
 * 
 * @export
 * @interface InspectionsIdPutRequest
 */
export interface InspectionsIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof InspectionsIdPutRequest
     */
    'status'?: InspectionsIdPutRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InspectionsIdPutRequest
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionsIdPutRequest
     */
    'next_inspection_date'?: string;
}

export const InspectionsIdPutRequestStatusEnum = {
    Pending: 'pending',
    Passed: 'passed',
    Failed: 'failed'
} as const;

export type InspectionsIdPutRequestStatusEnum = typeof InspectionsIdPutRequestStatusEnum[keyof typeof InspectionsIdPutRequestStatusEnum];

/**
 * 
 * @export
 * @interface InspectionsPostRequest
 */
export interface InspectionsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof InspectionsPostRequest
     */
    'vehicle_id': string;
    /**
     * 
     * @type {string}
     * @memberof InspectionsPostRequest
     */
    'inspector_id': string;
    /**
     * 
     * @type {string}
     * @memberof InspectionsPostRequest
     */
    'inspection_date': string;
    /**
     * 
     * @type {string}
     * @memberof InspectionsPostRequest
     */
    'status': InspectionsPostRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InspectionsPostRequest
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionsPostRequest
     */
    'next_inspection_date'?: string;
}

export const InspectionsPostRequestStatusEnum = {
    Pending: 'pending',
    Passed: 'passed',
    Failed: 'failed'
} as const;

export type InspectionsPostRequestStatusEnum = typeof InspectionsPostRequestStatusEnum[keyof typeof InspectionsPostRequestStatusEnum];

/**
 * 
 * @export
 * @interface License
 */
export interface License {
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'id_license'?: string;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'license_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'license_type'?: LicenseLicenseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'issue_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'expiry_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'issuing_authority'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof License
     */
    'is_valid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'updated_at'?: string;
}

export const LicenseLicenseTypeEnum = {
    Car: 'car',
    Motorcycle: 'motorcycle',
    Scooter: 'scooter',
    Bike: 'bike'
} as const;

export type LicenseLicenseTypeEnum = typeof LicenseLicenseTypeEnum[keyof typeof LicenseLicenseTypeEnum];

/**
 * 
 * @export
 * @interface LicensesIdPutRequest
 */
export interface LicensesIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof LicensesIdPutRequest
     */
    'license_type'?: LicensesIdPutRequestLicenseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LicensesIdPutRequest
     */
    'expiry_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof LicensesIdPutRequest
     */
    'issuing_authority'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LicensesIdPutRequest
     */
    'is_valid'?: boolean;
}

export const LicensesIdPutRequestLicenseTypeEnum = {
    Car: 'car',
    Motorcycle: 'motorcycle',
    Scooter: 'scooter',
    Bike: 'bike'
} as const;

export type LicensesIdPutRequestLicenseTypeEnum = typeof LicensesIdPutRequestLicenseTypeEnum[keyof typeof LicensesIdPutRequestLicenseTypeEnum];

/**
 * 
 * @export
 * @interface LicensesPostRequest
 */
export interface LicensesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof LicensesPostRequest
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof LicensesPostRequest
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof LicensesPostRequest
     */
    'license_type': LicensesPostRequestLicenseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LicensesPostRequest
     */
    'issue_date': string;
    /**
     * 
     * @type {string}
     * @memberof LicensesPostRequest
     */
    'expiry_date': string;
    /**
     * 
     * @type {string}
     * @memberof LicensesPostRequest
     */
    'issuing_authority': string;
    /**
     * 
     * @type {boolean}
     * @memberof LicensesPostRequest
     */
    'is_valid'?: boolean;
}

export const LicensesPostRequestLicenseTypeEnum = {
    Car: 'car',
    Motorcycle: 'motorcycle',
    Scooter: 'scooter',
    Bike: 'bike'
} as const;

export type LicensesPostRequestLicenseTypeEnum = typeof LicensesPostRequestLicenseTypeEnum[keyof typeof LicensesPostRequestLicenseTypeEnum];

/**
 * 
 * @export
 * @interface NotificationLog
 */
export interface NotificationLog {
    /**
     * 
     * @type {string}
     * @memberof NotificationLog
     */
    'id_log'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationLog
     */
    'type'?: NotificationLogTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationLog
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationLog
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationLog
     */
    'status'?: NotificationLogStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationLog
     */
    'message_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationLog
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationLog
     */
    'created_at'?: string;
}

export const NotificationLogTypeEnum = {
    Email: 'email',
    Push: 'push',
    Sms: 'sms'
} as const;

export type NotificationLogTypeEnum = typeof NotificationLogTypeEnum[keyof typeof NotificationLogTypeEnum];
export const NotificationLogStatusEnum = {
    Sent: 'sent',
    Failed: 'failed',
    Pending: 'pending'
} as const;

export type NotificationLogStatusEnum = typeof NotificationLogStatusEnum[keyof typeof NotificationLogStatusEnum];

/**
 * 
 * @export
 * @interface NotificationsDeviceTokenPostRequest
 */
export interface NotificationsDeviceTokenPostRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationsDeviceTokenPostRequest
     */
    'deviceToken': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsDeviceTokenPostRequest
     */
    'deviceType': NotificationsDeviceTokenPostRequestDeviceTypeEnum;
}

export const NotificationsDeviceTokenPostRequestDeviceTypeEnum = {
    Ios: 'ios',
    Android: 'android',
    Web: 'web'
} as const;

export type NotificationsDeviceTokenPostRequestDeviceTypeEnum = typeof NotificationsDeviceTokenPostRequestDeviceTypeEnum[keyof typeof NotificationsDeviceTokenPostRequestDeviceTypeEnum];

/**
 * 
 * @export
 * @interface NotificationsPaymentPostRequest
 */
export interface NotificationsPaymentPostRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationsPaymentPostRequest
     */
    'userId': string;
    /**
     * 
     * @type {NotificationsPaymentPostRequestPaymentData}
     * @memberof NotificationsPaymentPostRequest
     */
    'paymentData': NotificationsPaymentPostRequestPaymentData;
    /**
     * 
     * @type {string}
     * @memberof NotificationsPaymentPostRequest
     */
    'type'?: NotificationsPaymentPostRequestTypeEnum;
}

export const NotificationsPaymentPostRequestTypeEnum = {
    Success: 'success',
    Failed: 'failed',
    Refund: 'refund'
} as const;

export type NotificationsPaymentPostRequestTypeEnum = typeof NotificationsPaymentPostRequestTypeEnum[keyof typeof NotificationsPaymentPostRequestTypeEnum];

/**
 * 
 * @export
 * @interface NotificationsPaymentPostRequestPaymentData
 */
export interface NotificationsPaymentPostRequestPaymentData {
    /**
     * 
     * @type {string}
     * @memberof NotificationsPaymentPostRequestPaymentData
     */
    'paymentId'?: string;
    /**
     * 
     * @type {number}
     * @memberof NotificationsPaymentPostRequestPaymentData
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface NotificationsPreferencesPutRequest
 */
export interface NotificationsPreferencesPutRequest {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsPreferencesPutRequest
     */
    'email_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsPreferencesPutRequest
     */
    'push_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsPreferencesPutRequest
     */
    'sms_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsPreferencesPutRequest
     */
    'rental_notifications'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsPreferencesPutRequest
     */
    'payment_notifications'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsPreferencesPutRequest
     */
    'promo_notifications'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsPreferencesPutRequest
     */
    'security_notifications'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsPreferencesPutRequest
     */
    'vehicle_notifications'?: boolean;
}
/**
 * 
 * @export
 * @interface NotificationsRentalPostRequest
 */
export interface NotificationsRentalPostRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationsRentalPostRequest
     */
    'userId': string;
    /**
     * 
     * @type {NotificationsRentalPostRequestRentalData}
     * @memberof NotificationsRentalPostRequest
     */
    'rentalData': NotificationsRentalPostRequestRentalData;
    /**
     * 
     * @type {string}
     * @memberof NotificationsRentalPostRequest
     */
    'type'?: NotificationsRentalPostRequestTypeEnum;
}

export const NotificationsRentalPostRequestTypeEnum = {
    Confirmation: 'confirmation',
    Reminder: 'reminder',
    Conflict: 'conflict',
    Cancelled: 'cancelled'
} as const;

export type NotificationsRentalPostRequestTypeEnum = typeof NotificationsRentalPostRequestTypeEnum[keyof typeof NotificationsRentalPostRequestTypeEnum];

/**
 * 
 * @export
 * @interface NotificationsRentalPostRequestRentalData
 */
export interface NotificationsRentalPostRequestRentalData {
    /**
     * 
     * @type {string}
     * @memberof NotificationsRentalPostRequestRentalData
     */
    'rentalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsRentalPostRequestRentalData
     */
    'vehicleBrand'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsRentalPostRequestRentalData
     */
    'vehicleModel'?: string;
}
/**
 * 
 * @export
 * @interface NotificationsTestUserIdPost200Response
 */
export interface NotificationsTestUserIdPost200Response {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsTestUserIdPost200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationsTestUserIdPost200Response
     */
    'message'?: string;
    /**
     * 
     * @type {object}
     * @memberof NotificationsTestUserIdPost200Response
     */
    'results'?: object;
}
/**
 * 
 * @export
 * @interface Payment
 */
export interface Payment {
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'id_payment'?: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'rental_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Payment
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'payment_method'?: PaymentPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'status'?: PaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'transaction_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'payment_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'updated_at'?: string;
}

export const PaymentPaymentMethodEnum = {
    CreditCard: 'credit_card',
    DebitCard: 'debit_card',
    Paypal: 'paypal',
    ApplePay: 'apple_pay',
    GooglePay: 'google_pay'
} as const;

export type PaymentPaymentMethodEnum = typeof PaymentPaymentMethodEnum[keyof typeof PaymentPaymentMethodEnum];
export const PaymentStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Failed: 'failed',
    Refunded: 'refunded'
} as const;

export type PaymentStatusEnum = typeof PaymentStatusEnum[keyof typeof PaymentStatusEnum];

/**
 * 
 * @export
 * @interface PaymentsIdPutRequest
 */
export interface PaymentsIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsIdPutRequest
     */
    'status'?: PaymentsIdPutRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentsIdPutRequest
     */
    'transaction_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentsIdPutRequest
     */
    'payment_date'?: string;
}

export const PaymentsIdPutRequestStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Failed: 'failed',
    Refunded: 'refunded'
} as const;

export type PaymentsIdPutRequestStatusEnum = typeof PaymentsIdPutRequestStatusEnum[keyof typeof PaymentsIdPutRequestStatusEnum];

/**
 * 
 * @export
 * @interface PaymentsPostRequest
 */
export interface PaymentsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsPostRequest
     */
    'rental_id': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentsPostRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentsPostRequest
     */
    'payment_method': PaymentsPostRequestPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentsPostRequest
     */
    'status'?: PaymentsPostRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentsPostRequest
     */
    'transaction_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentsPostRequest
     */
    'payment_date'?: string;
}

export const PaymentsPostRequestPaymentMethodEnum = {
    CreditCard: 'credit_card',
    DebitCard: 'debit_card',
    Paypal: 'paypal',
    ApplePay: 'apple_pay',
    GooglePay: 'google_pay'
} as const;

export type PaymentsPostRequestPaymentMethodEnum = typeof PaymentsPostRequestPaymentMethodEnum[keyof typeof PaymentsPostRequestPaymentMethodEnum];
export const PaymentsPostRequestStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Failed: 'failed',
    Refunded: 'refunded'
} as const;

export type PaymentsPostRequestStatusEnum = typeof PaymentsPostRequestStatusEnum[keyof typeof PaymentsPostRequestStatusEnum];

/**
 * 
 * @export
 * @interface PromoCode
 */
export interface PromoCode {
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'id_promo_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof PromoCode
     */
    'discount_percentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof PromoCode
     */
    'max_uses'?: number;
    /**
     * 
     * @type {number}
     * @memberof PromoCode
     */
    'current_uses'?: number;
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'valid_from'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'valid_until'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface PromoCodesIdPutRequest
 */
export interface PromoCodesIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof PromoCodesIdPutRequest
     */
    'discount_percentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof PromoCodesIdPutRequest
     */
    'max_uses'?: number;
    /**
     * 
     * @type {number}
     * @memberof PromoCodesIdPutRequest
     */
    'current_uses'?: number;
    /**
     * 
     * @type {string}
     * @memberof PromoCodesIdPutRequest
     */
    'valid_from'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCodesIdPutRequest
     */
    'valid_until'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCodesIdPutRequest
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface PromoCodesPostRequest
 */
export interface PromoCodesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodesPostRequest
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof PromoCodesPostRequest
     */
    'discount_percentage': number;
    /**
     * 
     * @type {number}
     * @memberof PromoCodesPostRequest
     */
    'max_uses'?: number;
    /**
     * 
     * @type {number}
     * @memberof PromoCodesPostRequest
     */
    'current_uses'?: number;
    /**
     * 
     * @type {string}
     * @memberof PromoCodesPostRequest
     */
    'valid_from': string;
    /**
     * 
     * @type {string}
     * @memberof PromoCodesPostRequest
     */
    'valid_until': string;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCodesPostRequest
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface Rental
 */
export interface Rental {
    /**
     * 
     * @type {string}
     * @memberof Rental
     */
    'id_rental'?: string;
    /**
     * 
     * @type {string}
     * @memberof Rental
     */
    'vehicle_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Rental
     */
    'renter_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Rental
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Rental
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Rental
     */
    'status'?: RentalStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof Rental
     */
    'total_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof Rental
     */
    'source'?: RentalSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof Rental
     */
    'owner_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Rental
     */
    'promo_code_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Rental
     */
    'discount_applied'?: number;
    /**
     * Type de véhicule (ex: voiture, moto, scooter)
     * @type {string}
     * @memberof Rental
     */
    'vehicle_type'?: string;
    /**
     * Nombre de kilomètres au début de la location
     * @type {number}
     * @memberof Rental
     */
    'nb_kilometre'?: number;
    /**
     * Lieu de départ de la location
     * @type {string}
     * @memberof Rental
     */
    'lieu_start'?: string;
    /**
     * 
     * @type {string}
     * @memberof Rental
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Rental
     */
    'updated_at'?: string;
}

export const RentalStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;

export type RentalStatusEnum = typeof RentalStatusEnum[keyof typeof RentalStatusEnum];
export const RentalSourceEnum = {
    App: 'app',
    Web: 'web',
    Api: 'api'
} as const;

export type RentalSourceEnum = typeof RentalSourceEnum[keyof typeof RentalSourceEnum];

/**
 * 
 * @export
 * @interface Review
 */
export interface Review {
    /**
     * 
     * @type {string}
     * @memberof Review
     */
    'id_review'?: string;
    /**
     * 
     * @type {string}
     * @memberof Review
     */
    'rental_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Review
     */
    'reviewer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Review
     */
    'reviewed_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Review
     */
    'rating'?: number;
    /**
     * 
     * @type {string}
     * @memberof Review
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof Review
     */
    'review_type'?: ReviewReviewTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Review
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Review
     */
    'updated_at'?: string;
}

export const ReviewReviewTypeEnum = {
    RenterToOwner: 'renter_to_owner',
    OwnerToRenter: 'owner_to_renter'
} as const;

export type ReviewReviewTypeEnum = typeof ReviewReviewTypeEnum[keyof typeof ReviewReviewTypeEnum];

/**
 * 
 * @export
 * @interface ReviewsIdPutRequest
 */
export interface ReviewsIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ReviewsIdPutRequest
     */
    'rating'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReviewsIdPutRequest
     */
    'comment'?: string;
}
/**
 * 
 * @export
 * @interface ReviewsPostRequest
 */
export interface ReviewsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReviewsPostRequest
     */
    'rental_id': string;
    /**
     * 
     * @type {string}
     * @memberof ReviewsPostRequest
     */
    'reviewer_id': string;
    /**
     * 
     * @type {string}
     * @memberof ReviewsPostRequest
     */
    'reviewed_id': string;
    /**
     * 
     * @type {number}
     * @memberof ReviewsPostRequest
     */
    'rating': number;
    /**
     * 
     * @type {string}
     * @memberof ReviewsPostRequest
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewsPostRequest
     */
    'review_type': ReviewsPostRequestReviewTypeEnum;
}

export const ReviewsPostRequestReviewTypeEnum = {
    RenterToOwner: 'renter_to_owner',
    OwnerToRenter: 'owner_to_renter'
} as const;

export type ReviewsPostRequestReviewTypeEnum = typeof ReviewsPostRequestReviewTypeEnum[keyof typeof ReviewsPostRequestReviewTypeEnum];

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id_user'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'birth_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'profile_photo'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'role'?: UserRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'average_rating'?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'total_reviews'?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'registration_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'last_login'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'license_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'contract_accepted'?: boolean;
    /**
     * Indique si l\'utilisateur a été vérifié/validé
     * @type {boolean}
     * @memberof User
     */
    'is_checked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updated_at'?: string;
}

export const UserRoleEnum = {
    User: 'user',
    Admin: 'admin',
    Moderator: 'moderator'
} as const;

export type UserRoleEnum = typeof UserRoleEnum[keyof typeof UserRoleEnum];

/**
 * 
 * @export
 * @interface UserDeviceToken
 */
export interface UserDeviceToken {
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    'id_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    'device_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    'device_type'?: UserDeviceTokenDeviceTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UserDeviceToken
     */
    'is_active'?: boolean;
}

export const UserDeviceTokenDeviceTypeEnum = {
    Ios: 'ios',
    Android: 'android',
    Web: 'web'
} as const;

export type UserDeviceTokenDeviceTypeEnum = typeof UserDeviceTokenDeviceTypeEnum[keyof typeof UserDeviceTokenDeviceTypeEnum];

/**
 * 
 * @export
 * @interface UserNotificationPreferences
 */
export interface UserNotificationPreferences {
    /**
     * 
     * @type {string}
     * @memberof UserNotificationPreferences
     */
    'id_preference'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationPreferences
     */
    'user_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserNotificationPreferences
     */
    'email_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserNotificationPreferences
     */
    'push_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserNotificationPreferences
     */
    'sms_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserNotificationPreferences
     */
    'rental_notifications'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserNotificationPreferences
     */
    'payment_notifications'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserNotificationPreferences
     */
    'promo_notifications'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserNotificationPreferences
     */
    'security_notifications'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserNotificationPreferences
     */
    'vehicle_notifications'?: boolean;
}
/**
 * 
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'id_vehicle'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'serial_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'vehicle_type'?: VehicleVehicleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'model'?: string;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'owner_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Vehicle
     */
    'is_platform_owned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Vehicle
     */
    'is_available'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'hourly_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'longitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'updated_at'?: string;
}

export const VehicleVehicleTypeEnum = {
    Scooter: 'scooter',
    Bike: 'bike',
    Car: 'car',
    Motorcycle: 'motorcycle'
} as const;

export type VehicleVehicleTypeEnum = typeof VehicleVehicleTypeEnum[keyof typeof VehicleVehicleTypeEnum];

/**
 * 
 * @export
 * @interface VehicleInspection
 */
export interface VehicleInspection {
    /**
     * 
     * @type {string}
     * @memberof VehicleInspection
     */
    'id_inspection'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleInspection
     */
    'vehicle_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleInspection
     */
    'inspector_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleInspection
     */
    'inspection_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleInspection
     */
    'status'?: VehicleInspectionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VehicleInspection
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleInspection
     */
    'next_inspection_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleInspection
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleInspection
     */
    'updated_at'?: string;
}

export const VehicleInspectionStatusEnum = {
    Pending: 'pending',
    Passed: 'passed',
    Failed: 'failed'
} as const;

export type VehicleInspectionStatusEnum = typeof VehicleInspectionStatusEnum[keyof typeof VehicleInspectionStatusEnum];

/**
 * 
 * @export
 * @interface Verification
 */
export interface Verification {
    /**
     * 
     * @type {string}
     * @memberof Verification
     */
    'id_verification'?: string;
    /**
     * 
     * @type {string}
     * @memberof Verification
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Verification
     */
    'verification_type'?: VerificationVerificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Verification
     */
    'status'?: VerificationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Verification
     */
    'document_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof Verification
     */
    'submitted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Verification
     */
    'reviewed_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Verification
     */
    'reviewer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Verification
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof Verification
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Verification
     */
    'updated_at'?: string;
}

export const VerificationVerificationTypeEnum = {
    Identity: 'identity',
    License: 'license',
    VehicleOwnership: 'vehicle_ownership',
    Insurance: 'insurance'
} as const;

export type VerificationVerificationTypeEnum = typeof VerificationVerificationTypeEnum[keyof typeof VerificationVerificationTypeEnum];
export const VerificationStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type VerificationStatusEnum = typeof VerificationStatusEnum[keyof typeof VerificationStatusEnum];

/**
 * 
 * @export
 * @interface VerificationsIdPutRequest
 */
export interface VerificationsIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof VerificationsIdPutRequest
     */
    'status'?: VerificationsIdPutRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VerificationsIdPutRequest
     */
    'reviewed_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationsIdPutRequest
     */
    'reviewer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationsIdPutRequest
     */
    'notes'?: string;
}

export const VerificationsIdPutRequestStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type VerificationsIdPutRequestStatusEnum = typeof VerificationsIdPutRequestStatusEnum[keyof typeof VerificationsIdPutRequestStatusEnum];

/**
 * 
 * @export
 * @interface VerificationsPostRequest
 */
export interface VerificationsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof VerificationsPostRequest
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationsPostRequest
     */
    'verification_type': VerificationsPostRequestVerificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VerificationsPostRequest
     */
    'status'?: VerificationsPostRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VerificationsPostRequest
     */
    'document_url': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationsPostRequest
     */
    'submitted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationsPostRequest
     */
    'reviewed_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationsPostRequest
     */
    'reviewer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationsPostRequest
     */
    'notes'?: string;
}

export const VerificationsPostRequestVerificationTypeEnum = {
    Identity: 'identity',
    License: 'license',
    VehicleOwnership: 'vehicle_ownership',
    Insurance: 'insurance'
} as const;

export type VerificationsPostRequestVerificationTypeEnum = typeof VerificationsPostRequestVerificationTypeEnum[keyof typeof VerificationsPostRequestVerificationTypeEnum];
export const VerificationsPostRequestStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type VerificationsPostRequestStatusEnum = typeof VerificationsPostRequestStatusEnum[keyof typeof VerificationsPostRequestStatusEnum];


/**
 * AuthentificationApi - axios parameter creator
 * @export
 */
export const AuthentificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Connexion utilisateur
         * @param {ApiUsersLoginPostRequest} apiUsersLoginPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersLoginPost: async (apiUsersLoginPostRequest: ApiUsersLoginPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiUsersLoginPostRequest' is not null or undefined
            assertParamExists('apiUsersLoginPost', 'apiUsersLoginPostRequest', apiUsersLoginPostRequest)
            const localVarPath = `/api/users/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUsersLoginPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Inscription d\'un nouvel utilisateur
         * @param {ApiUsersRegisterPostRequest} apiUsersRegisterPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersRegisterPost: async (apiUsersRegisterPostRequest: ApiUsersRegisterPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiUsersRegisterPostRequest' is not null or undefined
            assertParamExists('apiUsersRegisterPost', 'apiUsersRegisterPostRequest', apiUsersRegisterPostRequest)
            const localVarPath = `/api/users/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUsersRegisterPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Demander la réinitialisation de mot de passe
         * @param {ApiUsersRequestPasswordResetPostRequest} apiUsersRequestPasswordResetPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersRequestPasswordResetPost: async (apiUsersRequestPasswordResetPostRequest: ApiUsersRequestPasswordResetPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiUsersRequestPasswordResetPostRequest' is not null or undefined
            assertParamExists('apiUsersRequestPasswordResetPost', 'apiUsersRequestPasswordResetPostRequest', apiUsersRequestPasswordResetPostRequest)
            const localVarPath = `/api/users/request-password-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUsersRequestPasswordResetPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Réinitialiser le mot de passe avec un token
         * @param {ApiUsersResetPasswordPostRequest} apiUsersResetPasswordPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersResetPasswordPost: async (apiUsersResetPasswordPostRequest: ApiUsersResetPasswordPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiUsersResetPasswordPostRequest' is not null or undefined
            assertParamExists('apiUsersResetPasswordPost', 'apiUsersResetPasswordPostRequest', apiUsersResetPasswordPostRequest)
            const localVarPath = `/api/users/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUsersResetPasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthentificationApi - functional programming interface
 * @export
 */
export const AuthentificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthentificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Connexion utilisateur
         * @param {ApiUsersLoginPostRequest} apiUsersLoginPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersLoginPost(apiUsersLoginPostRequest: ApiUsersLoginPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUsersLoginPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersLoginPost(apiUsersLoginPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthentificationApi.apiUsersLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Inscription d\'un nouvel utilisateur
         * @param {ApiUsersRegisterPostRequest} apiUsersRegisterPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersRegisterPost(apiUsersRegisterPostRequest: ApiUsersRegisterPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersRegisterPost(apiUsersRegisterPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthentificationApi.apiUsersRegisterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Demander la réinitialisation de mot de passe
         * @param {ApiUsersRequestPasswordResetPostRequest} apiUsersRequestPasswordResetPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersRequestPasswordResetPost(apiUsersRequestPasswordResetPostRequest: ApiUsersRequestPasswordResetPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersRequestPasswordResetPost(apiUsersRequestPasswordResetPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthentificationApi.apiUsersRequestPasswordResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Réinitialiser le mot de passe avec un token
         * @param {ApiUsersResetPasswordPostRequest} apiUsersResetPasswordPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersResetPasswordPost(apiUsersResetPasswordPostRequest: ApiUsersResetPasswordPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersResetPasswordPost(apiUsersResetPasswordPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthentificationApi.apiUsersResetPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthentificationApi - factory interface
 * @export
 */
export const AuthentificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthentificationApiFp(configuration)
    return {
        /**
         * 
         * @summary Connexion utilisateur
         * @param {ApiUsersLoginPostRequest} apiUsersLoginPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersLoginPost(apiUsersLoginPostRequest: ApiUsersLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiUsersLoginPost200Response> {
            return localVarFp.apiUsersLoginPost(apiUsersLoginPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Inscription d\'un nouvel utilisateur
         * @param {ApiUsersRegisterPostRequest} apiUsersRegisterPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersRegisterPost(apiUsersRegisterPostRequest: ApiUsersRegisterPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.apiUsersRegisterPost(apiUsersRegisterPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Demander la réinitialisation de mot de passe
         * @param {ApiUsersRequestPasswordResetPostRequest} apiUsersRequestPasswordResetPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersRequestPasswordResetPost(apiUsersRequestPasswordResetPostRequest: ApiUsersRequestPasswordResetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiUsersRequestPasswordResetPost(apiUsersRequestPasswordResetPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Réinitialiser le mot de passe avec un token
         * @param {ApiUsersResetPasswordPostRequest} apiUsersResetPasswordPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersResetPasswordPost(apiUsersResetPasswordPostRequest: ApiUsersResetPasswordPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiUsersResetPasswordPost(apiUsersResetPasswordPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthentificationApi - object-oriented interface
 * @export
 * @class AuthentificationApi
 * @extends {BaseAPI}
 */
export class AuthentificationApi extends BaseAPI {
    /**
     * 
     * @summary Connexion utilisateur
     * @param {ApiUsersLoginPostRequest} apiUsersLoginPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthentificationApi
     */
    public apiUsersLoginPost(apiUsersLoginPostRequest: ApiUsersLoginPostRequest, options?: RawAxiosRequestConfig) {
        return AuthentificationApiFp(this.configuration).apiUsersLoginPost(apiUsersLoginPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Inscription d\'un nouvel utilisateur
     * @param {ApiUsersRegisterPostRequest} apiUsersRegisterPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthentificationApi
     */
    public apiUsersRegisterPost(apiUsersRegisterPostRequest: ApiUsersRegisterPostRequest, options?: RawAxiosRequestConfig) {
        return AuthentificationApiFp(this.configuration).apiUsersRegisterPost(apiUsersRegisterPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Demander la réinitialisation de mot de passe
     * @param {ApiUsersRequestPasswordResetPostRequest} apiUsersRequestPasswordResetPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthentificationApi
     */
    public apiUsersRequestPasswordResetPost(apiUsersRequestPasswordResetPostRequest: ApiUsersRequestPasswordResetPostRequest, options?: RawAxiosRequestConfig) {
        return AuthentificationApiFp(this.configuration).apiUsersRequestPasswordResetPost(apiUsersRequestPasswordResetPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Réinitialiser le mot de passe avec un token
     * @param {ApiUsersResetPasswordPostRequest} apiUsersResetPasswordPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthentificationApi
     */
    public apiUsersResetPasswordPost(apiUsersResetPasswordPostRequest: ApiUsersResetPasswordPostRequest, options?: RawAxiosRequestConfig) {
        return AuthentificationApiFp(this.configuration).apiUsersResetPasswordPost(apiUsersResetPasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DiscountsApi - axios parameter creator
 * @export
 */
export const DiscountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Liste de tous les codes promo
         * @param {boolean} [isActive] Filtrer par statut actif
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodesGet: async (isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/promo-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer un code promo par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('promoCodesIdGet', 'id', id)
            const localVarPath = `/promo-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mettre à jour un code promo
         * @param {string} id 
         * @param {PromoCodesIdPutRequest} promoCodesIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodesIdPut: async (id: string, promoCodesIdPutRequest: PromoCodesIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('promoCodesIdPut', 'id', id)
            // verify required parameter 'promoCodesIdPutRequest' is not null or undefined
            assertParamExists('promoCodesIdPut', 'promoCodesIdPutRequest', promoCodesIdPutRequest)
            const localVarPath = `/promo-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promoCodesIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Créer un nouveau code promo
         * @param {PromoCodesPostRequest} promoCodesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodesPost: async (promoCodesPostRequest: PromoCodesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promoCodesPostRequest' is not null or undefined
            assertParamExists('promoCodesPost', 'promoCodesPostRequest', promoCodesPostRequest)
            const localVarPath = `/promo-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promoCodesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Valider un code promo
         * @param {string} code Code promo à valider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodesValidateCodeGet: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('promoCodesValidateCodeGet', 'code', code)
            const localVarPath = `/promo-codes/validate/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiscountsApi - functional programming interface
 * @export
 */
export const DiscountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiscountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Liste de tous les codes promo
         * @param {boolean} [isActive] Filtrer par statut actif
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoCodesGet(isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromoCode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoCodesGet(isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.promoCodesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupérer un code promo par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoCodesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoCodesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.promoCodesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mettre à jour un code promo
         * @param {string} id 
         * @param {PromoCodesIdPutRequest} promoCodesIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoCodesIdPut(id: string, promoCodesIdPutRequest: PromoCodesIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoCodesIdPut(id, promoCodesIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.promoCodesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Créer un nouveau code promo
         * @param {PromoCodesPostRequest} promoCodesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoCodesPost(promoCodesPostRequest: PromoCodesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoCodesPost(promoCodesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.promoCodesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Valider un code promo
         * @param {string} code Code promo à valider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoCodesValidateCodeGet(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoCodesValidateCodeGet(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.promoCodesValidateCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiscountsApi - factory interface
 * @export
 */
export const DiscountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiscountsApiFp(configuration)
    return {
        /**
         * 
         * @summary Liste de tous les codes promo
         * @param {boolean} [isActive] Filtrer par statut actif
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodesGet(isActive?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<PromoCode>> {
            return localVarFp.promoCodesGet(isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer un code promo par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PromoCode> {
            return localVarFp.promoCodesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mettre à jour un code promo
         * @param {string} id 
         * @param {PromoCodesIdPutRequest} promoCodesIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodesIdPut(id: string, promoCodesIdPutRequest: PromoCodesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromoCode> {
            return localVarFp.promoCodesIdPut(id, promoCodesIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Créer un nouveau code promo
         * @param {PromoCodesPostRequest} promoCodesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodesPost(promoCodesPostRequest: PromoCodesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromoCode> {
            return localVarFp.promoCodesPost(promoCodesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Valider un code promo
         * @param {string} code Code promo à valider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodesValidateCodeGet(code: string, options?: RawAxiosRequestConfig): AxiosPromise<PromoCode> {
            return localVarFp.promoCodesValidateCodeGet(code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DiscountsApi - object-oriented interface
 * @export
 * @class DiscountsApi
 * @extends {BaseAPI}
 */
export class DiscountsApi extends BaseAPI {
    /**
     * 
     * @summary Liste de tous les codes promo
     * @param {boolean} [isActive] Filtrer par statut actif
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public promoCodesGet(isActive?: boolean, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).promoCodesGet(isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer un code promo par ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public promoCodesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).promoCodesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mettre à jour un code promo
     * @param {string} id 
     * @param {PromoCodesIdPutRequest} promoCodesIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public promoCodesIdPut(id: string, promoCodesIdPutRequest: PromoCodesIdPutRequest, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).promoCodesIdPut(id, promoCodesIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Créer un nouveau code promo
     * @param {PromoCodesPostRequest} promoCodesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public promoCodesPost(promoCodesPostRequest: PromoCodesPostRequest, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).promoCodesPost(promoCodesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Valider un code promo
     * @param {string} code Code promo à valider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public promoCodesValidateCodeGet(code: string, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).promoCodesValidateCodeGet(code, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailApi - axios parameter creator
 * @export
 */
export const EmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Envoyer un email personnalisé avec texte libre
         * @param {ApiEmailCustomPostRequest} apiEmailCustomPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailCustomPost: async (apiEmailCustomPostRequest: ApiEmailCustomPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiEmailCustomPostRequest' is not null or undefined
            assertParamExists('apiEmailCustomPost', 'apiEmailCustomPostRequest', apiEmailCustomPostRequest)
            const localVarPath = `/api/email/custom`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiEmailCustomPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Envoyer un email avec template générique personnalisé
         * @param {ApiEmailGenericTemplatePostRequest} apiEmailGenericTemplatePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailGenericTemplatePost: async (apiEmailGenericTemplatePostRequest: ApiEmailGenericTemplatePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiEmailGenericTemplatePostRequest' is not null or undefined
            assertParamExists('apiEmailGenericTemplatePost', 'apiEmailGenericTemplatePostRequest', apiEmailGenericTemplatePostRequest)
            const localVarPath = `/api/email/generic-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiEmailGenericTemplatePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Envoyer un email de réinitialisation de mot de passe
         * @param {ApiEmailPasswordResetPostRequest} apiEmailPasswordResetPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailPasswordResetPost: async (apiEmailPasswordResetPostRequest: ApiEmailPasswordResetPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiEmailPasswordResetPostRequest' is not null or undefined
            assertParamExists('apiEmailPasswordResetPost', 'apiEmailPasswordResetPostRequest', apiEmailPasswordResetPostRequest)
            const localVarPath = `/api/email/password-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiEmailPasswordResetPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Envoyer un email de confirmation de location
         * @param {ApiEmailRentalConfirmationPostRequest} apiEmailRentalConfirmationPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailRentalConfirmationPost: async (apiEmailRentalConfirmationPostRequest: ApiEmailRentalConfirmationPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiEmailRentalConfirmationPostRequest' is not null or undefined
            assertParamExists('apiEmailRentalConfirmationPost', 'apiEmailRentalConfirmationPostRequest', apiEmailRentalConfirmationPostRequest)
            const localVarPath = `/api/email/rental-confirmation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiEmailRentalConfirmationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Envoyer un email de confirmation de demande (style Dingo)
         * @param {ApiEmailRequestConfirmationPostRequest} apiEmailRequestConfirmationPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailRequestConfirmationPost: async (apiEmailRequestConfirmationPostRequest: ApiEmailRequestConfirmationPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiEmailRequestConfirmationPostRequest' is not null or undefined
            assertParamExists('apiEmailRequestConfirmationPost', 'apiEmailRequestConfirmationPostRequest', apiEmailRequestConfirmationPostRequest)
            const localVarPath = `/api/email/request-confirmation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiEmailRequestConfirmationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Tester l\'envoi d\'email
         * @param {ApiEmailTestPostRequest} apiEmailTestPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailTestPost: async (apiEmailTestPostRequest: ApiEmailTestPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiEmailTestPostRequest' is not null or undefined
            assertParamExists('apiEmailTestPost', 'apiEmailTestPostRequest', apiEmailTestPostRequest)
            const localVarPath = `/api/email/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiEmailTestPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Envoyer un email de bienvenue
         * @param {ApiEmailWelcomePostRequest} apiEmailWelcomePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailWelcomePost: async (apiEmailWelcomePostRequest: ApiEmailWelcomePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiEmailWelcomePostRequest' is not null or undefined
            assertParamExists('apiEmailWelcomePost', 'apiEmailWelcomePostRequest', apiEmailWelcomePostRequest)
            const localVarPath = `/api/email/welcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiEmailWelcomePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailApi - functional programming interface
 * @export
 */
export const EmailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Envoyer un email personnalisé avec texte libre
         * @param {ApiEmailCustomPostRequest} apiEmailCustomPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEmailCustomPost(apiEmailCustomPostRequest: ApiEmailCustomPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEmailCustomPost(apiEmailCustomPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailApi.apiEmailCustomPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Envoyer un email avec template générique personnalisé
         * @param {ApiEmailGenericTemplatePostRequest} apiEmailGenericTemplatePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEmailGenericTemplatePost(apiEmailGenericTemplatePostRequest: ApiEmailGenericTemplatePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEmailGenericTemplatePost(apiEmailGenericTemplatePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailApi.apiEmailGenericTemplatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Envoyer un email de réinitialisation de mot de passe
         * @param {ApiEmailPasswordResetPostRequest} apiEmailPasswordResetPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEmailPasswordResetPost(apiEmailPasswordResetPostRequest: ApiEmailPasswordResetPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEmailPasswordResetPost(apiEmailPasswordResetPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailApi.apiEmailPasswordResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Envoyer un email de confirmation de location
         * @param {ApiEmailRentalConfirmationPostRequest} apiEmailRentalConfirmationPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEmailRentalConfirmationPost(apiEmailRentalConfirmationPostRequest: ApiEmailRentalConfirmationPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEmailRentalConfirmationPost(apiEmailRentalConfirmationPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailApi.apiEmailRentalConfirmationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Envoyer un email de confirmation de demande (style Dingo)
         * @param {ApiEmailRequestConfirmationPostRequest} apiEmailRequestConfirmationPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEmailRequestConfirmationPost(apiEmailRequestConfirmationPostRequest: ApiEmailRequestConfirmationPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEmailRequestConfirmationPost(apiEmailRequestConfirmationPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailApi.apiEmailRequestConfirmationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Tester l\'envoi d\'email
         * @param {ApiEmailTestPostRequest} apiEmailTestPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEmailTestPost(apiEmailTestPostRequest: ApiEmailTestPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEmailTestPost(apiEmailTestPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailApi.apiEmailTestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Envoyer un email de bienvenue
         * @param {ApiEmailWelcomePostRequest} apiEmailWelcomePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEmailWelcomePost(apiEmailWelcomePostRequest: ApiEmailWelcomePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEmailWelcomePost(apiEmailWelcomePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailApi.apiEmailWelcomePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailApi - factory interface
 * @export
 */
export const EmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailApiFp(configuration)
    return {
        /**
         * 
         * @summary Envoyer un email personnalisé avec texte libre
         * @param {ApiEmailCustomPostRequest} apiEmailCustomPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailCustomPost(apiEmailCustomPostRequest: ApiEmailCustomPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEmailCustomPost(apiEmailCustomPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envoyer un email avec template générique personnalisé
         * @param {ApiEmailGenericTemplatePostRequest} apiEmailGenericTemplatePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailGenericTemplatePost(apiEmailGenericTemplatePostRequest: ApiEmailGenericTemplatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEmailGenericTemplatePost(apiEmailGenericTemplatePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envoyer un email de réinitialisation de mot de passe
         * @param {ApiEmailPasswordResetPostRequest} apiEmailPasswordResetPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailPasswordResetPost(apiEmailPasswordResetPostRequest: ApiEmailPasswordResetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEmailPasswordResetPost(apiEmailPasswordResetPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envoyer un email de confirmation de location
         * @param {ApiEmailRentalConfirmationPostRequest} apiEmailRentalConfirmationPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailRentalConfirmationPost(apiEmailRentalConfirmationPostRequest: ApiEmailRentalConfirmationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEmailRentalConfirmationPost(apiEmailRentalConfirmationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envoyer un email de confirmation de demande (style Dingo)
         * @param {ApiEmailRequestConfirmationPostRequest} apiEmailRequestConfirmationPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailRequestConfirmationPost(apiEmailRequestConfirmationPostRequest: ApiEmailRequestConfirmationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEmailRequestConfirmationPost(apiEmailRequestConfirmationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Tester l\'envoi d\'email
         * @param {ApiEmailTestPostRequest} apiEmailTestPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailTestPost(apiEmailTestPostRequest: ApiEmailTestPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEmailTestPost(apiEmailTestPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envoyer un email de bienvenue
         * @param {ApiEmailWelcomePostRequest} apiEmailWelcomePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailWelcomePost(apiEmailWelcomePostRequest: ApiEmailWelcomePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEmailWelcomePost(apiEmailWelcomePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailApi - object-oriented interface
 * @export
 * @class EmailApi
 * @extends {BaseAPI}
 */
export class EmailApi extends BaseAPI {
    /**
     * 
     * @summary Envoyer un email personnalisé avec texte libre
     * @param {ApiEmailCustomPostRequest} apiEmailCustomPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public apiEmailCustomPost(apiEmailCustomPostRequest: ApiEmailCustomPostRequest, options?: RawAxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiEmailCustomPost(apiEmailCustomPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envoyer un email avec template générique personnalisé
     * @param {ApiEmailGenericTemplatePostRequest} apiEmailGenericTemplatePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public apiEmailGenericTemplatePost(apiEmailGenericTemplatePostRequest: ApiEmailGenericTemplatePostRequest, options?: RawAxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiEmailGenericTemplatePost(apiEmailGenericTemplatePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envoyer un email de réinitialisation de mot de passe
     * @param {ApiEmailPasswordResetPostRequest} apiEmailPasswordResetPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public apiEmailPasswordResetPost(apiEmailPasswordResetPostRequest: ApiEmailPasswordResetPostRequest, options?: RawAxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiEmailPasswordResetPost(apiEmailPasswordResetPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envoyer un email de confirmation de location
     * @param {ApiEmailRentalConfirmationPostRequest} apiEmailRentalConfirmationPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public apiEmailRentalConfirmationPost(apiEmailRentalConfirmationPostRequest: ApiEmailRentalConfirmationPostRequest, options?: RawAxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiEmailRentalConfirmationPost(apiEmailRentalConfirmationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envoyer un email de confirmation de demande (style Dingo)
     * @param {ApiEmailRequestConfirmationPostRequest} apiEmailRequestConfirmationPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public apiEmailRequestConfirmationPost(apiEmailRequestConfirmationPostRequest: ApiEmailRequestConfirmationPostRequest, options?: RawAxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiEmailRequestConfirmationPost(apiEmailRequestConfirmationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Tester l\'envoi d\'email
     * @param {ApiEmailTestPostRequest} apiEmailTestPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public apiEmailTestPost(apiEmailTestPostRequest: ApiEmailTestPostRequest, options?: RawAxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiEmailTestPost(apiEmailTestPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envoyer un email de bienvenue
     * @param {ApiEmailWelcomePostRequest} apiEmailWelcomePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public apiEmailWelcomePost(apiEmailWelcomePostRequest: ApiEmailWelcomePostRequest, options?: RawAxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiEmailWelcomePost(apiEmailWelcomePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InspectionsApi - axios parameter creator
 * @export
 */
export const InspectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Liste de toutes les inspections
         * @param {InspectionsGetStatusEnum} [status] Filtrer par statut
         * @param {string} [vehicleId] Filtrer par véhicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionsGet: async (status?: InspectionsGetStatusEnum, vehicleId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/inspections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicle_id'] = vehicleId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Supprimer une inspection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('inspectionsIdDelete', 'id', id)
            const localVarPath = `/inspections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer une inspection par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('inspectionsIdGet', 'id', id)
            const localVarPath = `/inspections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mettre à jour une inspection
         * @param {string} id 
         * @param {InspectionsIdPutRequest} inspectionsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionsIdPut: async (id: string, inspectionsIdPutRequest: InspectionsIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('inspectionsIdPut', 'id', id)
            // verify required parameter 'inspectionsIdPutRequest' is not null or undefined
            assertParamExists('inspectionsIdPut', 'inspectionsIdPutRequest', inspectionsIdPutRequest)
            const localVarPath = `/inspections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inspectionsIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Créer une nouvelle inspection
         * @param {InspectionsPostRequest} inspectionsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionsPost: async (inspectionsPostRequest: InspectionsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inspectionsPostRequest' is not null or undefined
            assertParamExists('inspectionsPost', 'inspectionsPostRequest', inspectionsPostRequest)
            const localVarPath = `/inspections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inspectionsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InspectionsApi - functional programming interface
 * @export
 */
export const InspectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InspectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Liste de toutes les inspections
         * @param {InspectionsGetStatusEnum} [status] Filtrer par statut
         * @param {string} [vehicleId] Filtrer par véhicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectionsGet(status?: InspectionsGetStatusEnum, vehicleId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleInspection>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectionsGet(status, vehicleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.inspectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Supprimer une inspection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectionsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectionsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.inspectionsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupérer une inspection par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectionsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleInspection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.inspectionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mettre à jour une inspection
         * @param {string} id 
         * @param {InspectionsIdPutRequest} inspectionsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectionsIdPut(id: string, inspectionsIdPutRequest: InspectionsIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleInspection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectionsIdPut(id, inspectionsIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.inspectionsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Créer une nouvelle inspection
         * @param {InspectionsPostRequest} inspectionsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectionsPost(inspectionsPostRequest: InspectionsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleInspection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectionsPost(inspectionsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.inspectionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InspectionsApi - factory interface
 * @export
 */
export const InspectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InspectionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Liste de toutes les inspections
         * @param {InspectionsGetStatusEnum} [status] Filtrer par statut
         * @param {string} [vehicleId] Filtrer par véhicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionsGet(status?: InspectionsGetStatusEnum, vehicleId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<VehicleInspection>> {
            return localVarFp.inspectionsGet(status, vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Supprimer une inspection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.inspectionsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer une inspection par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<VehicleInspection> {
            return localVarFp.inspectionsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mettre à jour une inspection
         * @param {string} id 
         * @param {InspectionsIdPutRequest} inspectionsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionsIdPut(id: string, inspectionsIdPutRequest: InspectionsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleInspection> {
            return localVarFp.inspectionsIdPut(id, inspectionsIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Créer une nouvelle inspection
         * @param {InspectionsPostRequest} inspectionsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionsPost(inspectionsPostRequest: InspectionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleInspection> {
            return localVarFp.inspectionsPost(inspectionsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InspectionsApi - object-oriented interface
 * @export
 * @class InspectionsApi
 * @extends {BaseAPI}
 */
export class InspectionsApi extends BaseAPI {
    /**
     * 
     * @summary Liste de toutes les inspections
     * @param {InspectionsGetStatusEnum} [status] Filtrer par statut
     * @param {string} [vehicleId] Filtrer par véhicule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public inspectionsGet(status?: InspectionsGetStatusEnum, vehicleId?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).inspectionsGet(status, vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Supprimer une inspection
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public inspectionsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).inspectionsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer une inspection par ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public inspectionsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).inspectionsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mettre à jour une inspection
     * @param {string} id 
     * @param {InspectionsIdPutRequest} inspectionsIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public inspectionsIdPut(id: string, inspectionsIdPutRequest: InspectionsIdPutRequest, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).inspectionsIdPut(id, inspectionsIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Créer une nouvelle inspection
     * @param {InspectionsPostRequest} inspectionsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public inspectionsPost(inspectionsPostRequest: InspectionsPostRequest, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).inspectionsPost(inspectionsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const InspectionsGetStatusEnum = {
    Pending: 'pending',
    Passed: 'passed',
    Failed: 'failed'
} as const;
export type InspectionsGetStatusEnum = typeof InspectionsGetStatusEnum[keyof typeof InspectionsGetStatusEnum];


/**
 * LicensesApi - axios parameter creator
 * @export
 */
export const LicensesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Liste de toutes les licences
         * @param {string} [userId] Filtrer par utilisateur
         * @param {LicensesGetLicenseTypeEnum} [licenseType] Filtrer par type de licence
         * @param {boolean} [isValid] Filtrer par validité
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licensesGet: async (userId?: string, licenseType?: LicensesGetLicenseTypeEnum, isValid?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/licenses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (licenseType !== undefined) {
                localVarQueryParameter['license_type'] = licenseType;
            }

            if (isValid !== undefined) {
                localVarQueryParameter['is_valid'] = isValid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Supprimer une licence
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licensesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('licensesIdDelete', 'id', id)
            const localVarPath = `/licenses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer une licence par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licensesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('licensesIdGet', 'id', id)
            const localVarPath = `/licenses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mettre à jour une licence
         * @param {string} id 
         * @param {LicensesIdPutRequest} licensesIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licensesIdPut: async (id: string, licensesIdPutRequest: LicensesIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('licensesIdPut', 'id', id)
            // verify required parameter 'licensesIdPutRequest' is not null or undefined
            assertParamExists('licensesIdPut', 'licensesIdPutRequest', licensesIdPutRequest)
            const localVarPath = `/licenses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(licensesIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Créer une nouvelle licence
         * @param {LicensesPostRequest} licensesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licensesPost: async (licensesPostRequest: LicensesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'licensesPostRequest' is not null or undefined
            assertParamExists('licensesPost', 'licensesPostRequest', licensesPostRequest)
            const localVarPath = `/licenses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(licensesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LicensesApi - functional programming interface
 * @export
 */
export const LicensesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LicensesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Liste de toutes les licences
         * @param {string} [userId] Filtrer par utilisateur
         * @param {LicensesGetLicenseTypeEnum} [licenseType] Filtrer par type de licence
         * @param {boolean} [isValid] Filtrer par validité
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async licensesGet(userId?: string, licenseType?: LicensesGetLicenseTypeEnum, isValid?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<License>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.licensesGet(userId, licenseType, isValid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicensesApi.licensesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Supprimer une licence
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async licensesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.licensesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicensesApi.licensesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupérer une licence par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async licensesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<License>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.licensesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicensesApi.licensesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mettre à jour une licence
         * @param {string} id 
         * @param {LicensesIdPutRequest} licensesIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async licensesIdPut(id: string, licensesIdPutRequest: LicensesIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<License>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.licensesIdPut(id, licensesIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicensesApi.licensesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Créer une nouvelle licence
         * @param {LicensesPostRequest} licensesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async licensesPost(licensesPostRequest: LicensesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<License>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.licensesPost(licensesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicensesApi.licensesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LicensesApi - factory interface
 * @export
 */
export const LicensesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LicensesApiFp(configuration)
    return {
        /**
         * 
         * @summary Liste de toutes les licences
         * @param {string} [userId] Filtrer par utilisateur
         * @param {LicensesGetLicenseTypeEnum} [licenseType] Filtrer par type de licence
         * @param {boolean} [isValid] Filtrer par validité
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licensesGet(userId?: string, licenseType?: LicensesGetLicenseTypeEnum, isValid?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<License>> {
            return localVarFp.licensesGet(userId, licenseType, isValid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Supprimer une licence
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licensesIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.licensesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer une licence par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licensesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<License> {
            return localVarFp.licensesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mettre à jour une licence
         * @param {string} id 
         * @param {LicensesIdPutRequest} licensesIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licensesIdPut(id: string, licensesIdPutRequest: LicensesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<License> {
            return localVarFp.licensesIdPut(id, licensesIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Créer une nouvelle licence
         * @param {LicensesPostRequest} licensesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licensesPost(licensesPostRequest: LicensesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<License> {
            return localVarFp.licensesPost(licensesPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LicensesApi - object-oriented interface
 * @export
 * @class LicensesApi
 * @extends {BaseAPI}
 */
export class LicensesApi extends BaseAPI {
    /**
     * 
     * @summary Liste de toutes les licences
     * @param {string} [userId] Filtrer par utilisateur
     * @param {LicensesGetLicenseTypeEnum} [licenseType] Filtrer par type de licence
     * @param {boolean} [isValid] Filtrer par validité
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicensesApi
     */
    public licensesGet(userId?: string, licenseType?: LicensesGetLicenseTypeEnum, isValid?: boolean, options?: RawAxiosRequestConfig) {
        return LicensesApiFp(this.configuration).licensesGet(userId, licenseType, isValid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Supprimer une licence
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicensesApi
     */
    public licensesIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return LicensesApiFp(this.configuration).licensesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer une licence par ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicensesApi
     */
    public licensesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return LicensesApiFp(this.configuration).licensesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mettre à jour une licence
     * @param {string} id 
     * @param {LicensesIdPutRequest} licensesIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicensesApi
     */
    public licensesIdPut(id: string, licensesIdPutRequest: LicensesIdPutRequest, options?: RawAxiosRequestConfig) {
        return LicensesApiFp(this.configuration).licensesIdPut(id, licensesIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Créer une nouvelle licence
     * @param {LicensesPostRequest} licensesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicensesApi
     */
    public licensesPost(licensesPostRequest: LicensesPostRequest, options?: RawAxiosRequestConfig) {
        return LicensesApiFp(this.configuration).licensesPost(licensesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const LicensesGetLicenseTypeEnum = {
    Car: 'car',
    Motorcycle: 'motorcycle',
    Scooter: 'scooter',
    Bike: 'bike'
} as const;
export type LicensesGetLicenseTypeEnum = typeof LicensesGetLicenseTypeEnum[keyof typeof LicensesGetLicenseTypeEnum];


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Enregistrer un token d\'appareil pour les notifications push
         * @param {NotificationsDeviceTokenPostRequest} notificationsDeviceTokenPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsDeviceTokenPost: async (notificationsDeviceTokenPostRequest: NotificationsDeviceTokenPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationsDeviceTokenPostRequest' is not null or undefined
            assertParamExists('notificationsDeviceTokenPost', 'notificationsDeviceTokenPostRequest', notificationsDeviceTokenPostRequest)
            const localVarPath = `/notifications/device-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationsDeviceTokenPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Supprimer un token d\'appareil
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsDeviceTokenTokenIdDelete: async (tokenId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenId' is not null or undefined
            assertParamExists('notificationsDeviceTokenTokenIdDelete', 'tokenId', tokenId)
            const localVarPath = `/notifications/device-token/{tokenId}`
                .replace(`{${"tokenId"}}`, encodeURIComponent(String(tokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer les logs de notification
         * @param {NotificationsLogsGetTypeEnum} [type] Filtrer par type de notification
         * @param {NotificationsLogsGetStatusEnum} [status] Filtrer par statut
         * @param {number} [limit] Nombre de résultats à retourner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsLogsGet: async (type?: NotificationsLogsGetTypeEnum, status?: NotificationsLogsGetStatusEnum, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Envoyer une notification de paiement
         * @param {NotificationsPaymentPostRequest} notificationsPaymentPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsPaymentPost: async (notificationsPaymentPostRequest: NotificationsPaymentPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationsPaymentPostRequest' is not null or undefined
            assertParamExists('notificationsPaymentPost', 'notificationsPaymentPostRequest', notificationsPaymentPostRequest)
            const localVarPath = `/notifications/payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationsPaymentPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer les préférences de notification de l\'utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsPreferencesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mettre à jour les préférences de notification
         * @param {NotificationsPreferencesPutRequest} notificationsPreferencesPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsPreferencesPut: async (notificationsPreferencesPutRequest: NotificationsPreferencesPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationsPreferencesPutRequest' is not null or undefined
            assertParamExists('notificationsPreferencesPut', 'notificationsPreferencesPutRequest', notificationsPreferencesPutRequest)
            const localVarPath = `/notifications/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationsPreferencesPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Envoyer une notification de réservation
         * @param {NotificationsRentalPostRequest} notificationsRentalPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsRentalPost: async (notificationsRentalPostRequest: NotificationsRentalPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationsRentalPostRequest' is not null or undefined
            assertParamExists('notificationsRentalPost', 'notificationsRentalPostRequest', notificationsRentalPostRequest)
            const localVarPath = `/notifications/rental`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationsRentalPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Envoyer une notification de test
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsTestUserIdPost: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('notificationsTestUserIdPost', 'userId', userId)
            const localVarPath = `/notifications/test/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Enregistrer un token d\'appareil pour les notifications push
         * @param {NotificationsDeviceTokenPostRequest} notificationsDeviceTokenPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsDeviceTokenPost(notificationsDeviceTokenPostRequest: NotificationsDeviceTokenPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsDeviceTokenPost(notificationsDeviceTokenPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsDeviceTokenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Supprimer un token d\'appareil
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsDeviceTokenTokenIdDelete(tokenId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsDeviceTokenTokenIdDelete(tokenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsDeviceTokenTokenIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupérer les logs de notification
         * @param {NotificationsLogsGetTypeEnum} [type] Filtrer par type de notification
         * @param {NotificationsLogsGetStatusEnum} [status] Filtrer par statut
         * @param {number} [limit] Nombre de résultats à retourner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsLogsGet(type?: NotificationsLogsGetTypeEnum, status?: NotificationsLogsGetStatusEnum, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsLogsGet(type, status, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsLogsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Envoyer une notification de paiement
         * @param {NotificationsPaymentPostRequest} notificationsPaymentPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsPaymentPost(notificationsPaymentPostRequest: NotificationsPaymentPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsPaymentPost(notificationsPaymentPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsPaymentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupérer les préférences de notification de l\'utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsPreferencesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsPreferencesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsPreferencesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mettre à jour les préférences de notification
         * @param {NotificationsPreferencesPutRequest} notificationsPreferencesPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsPreferencesPut(notificationsPreferencesPutRequest: NotificationsPreferencesPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsPreferencesPut(notificationsPreferencesPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsPreferencesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Envoyer une notification de réservation
         * @param {NotificationsRentalPostRequest} notificationsRentalPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsRentalPost(notificationsRentalPostRequest: NotificationsRentalPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsRentalPost(notificationsRentalPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsRentalPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Envoyer une notification de test
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsTestUserIdPost(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationsTestUserIdPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsTestUserIdPost(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsTestUserIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Enregistrer un token d\'appareil pour les notifications push
         * @param {NotificationsDeviceTokenPostRequest} notificationsDeviceTokenPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsDeviceTokenPost(notificationsDeviceTokenPostRequest: NotificationsDeviceTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationsDeviceTokenPost(notificationsDeviceTokenPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Supprimer un token d\'appareil
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsDeviceTokenTokenIdDelete(tokenId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationsDeviceTokenTokenIdDelete(tokenId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer les logs de notification
         * @param {NotificationsLogsGetTypeEnum} [type] Filtrer par type de notification
         * @param {NotificationsLogsGetStatusEnum} [status] Filtrer par statut
         * @param {number} [limit] Nombre de résultats à retourner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsLogsGet(type?: NotificationsLogsGetTypeEnum, status?: NotificationsLogsGetStatusEnum, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationLog>> {
            return localVarFp.notificationsLogsGet(type, status, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envoyer une notification de paiement
         * @param {NotificationsPaymentPostRequest} notificationsPaymentPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsPaymentPost(notificationsPaymentPostRequest: NotificationsPaymentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationsPaymentPost(notificationsPaymentPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer les préférences de notification de l\'utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsPreferencesGet(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferences> {
            return localVarFp.notificationsPreferencesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mettre à jour les préférences de notification
         * @param {NotificationsPreferencesPutRequest} notificationsPreferencesPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsPreferencesPut(notificationsPreferencesPutRequest: NotificationsPreferencesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationsPreferencesPut(notificationsPreferencesPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envoyer une notification de réservation
         * @param {NotificationsRentalPostRequest} notificationsRentalPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsRentalPost(notificationsRentalPostRequest: NotificationsRentalPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationsRentalPost(notificationsRentalPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envoyer une notification de test
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsTestUserIdPost(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationsTestUserIdPost200Response> {
            return localVarFp.notificationsTestUserIdPost(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Enregistrer un token d\'appareil pour les notifications push
     * @param {NotificationsDeviceTokenPostRequest} notificationsDeviceTokenPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsDeviceTokenPost(notificationsDeviceTokenPostRequest: NotificationsDeviceTokenPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsDeviceTokenPost(notificationsDeviceTokenPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Supprimer un token d\'appareil
     * @param {string} tokenId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsDeviceTokenTokenIdDelete(tokenId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsDeviceTokenTokenIdDelete(tokenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer les logs de notification
     * @param {NotificationsLogsGetTypeEnum} [type] Filtrer par type de notification
     * @param {NotificationsLogsGetStatusEnum} [status] Filtrer par statut
     * @param {number} [limit] Nombre de résultats à retourner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsLogsGet(type?: NotificationsLogsGetTypeEnum, status?: NotificationsLogsGetStatusEnum, limit?: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsLogsGet(type, status, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envoyer une notification de paiement
     * @param {NotificationsPaymentPostRequest} notificationsPaymentPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsPaymentPost(notificationsPaymentPostRequest: NotificationsPaymentPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsPaymentPost(notificationsPaymentPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer les préférences de notification de l\'utilisateur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsPreferencesGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsPreferencesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mettre à jour les préférences de notification
     * @param {NotificationsPreferencesPutRequest} notificationsPreferencesPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsPreferencesPut(notificationsPreferencesPutRequest: NotificationsPreferencesPutRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsPreferencesPut(notificationsPreferencesPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envoyer une notification de réservation
     * @param {NotificationsRentalPostRequest} notificationsRentalPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsRentalPost(notificationsRentalPostRequest: NotificationsRentalPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsRentalPost(notificationsRentalPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envoyer une notification de test
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsTestUserIdPost(userId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsTestUserIdPost(userId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const NotificationsLogsGetTypeEnum = {
    Email: 'email',
    Push: 'push',
    Sms: 'sms'
} as const;
export type NotificationsLogsGetTypeEnum = typeof NotificationsLogsGetTypeEnum[keyof typeof NotificationsLogsGetTypeEnum];
/**
 * @export
 */
export const NotificationsLogsGetStatusEnum = {
    Sent: 'sent',
    Failed: 'failed',
    Pending: 'pending'
} as const;
export type NotificationsLogsGetStatusEnum = typeof NotificationsLogsGetStatusEnum[keyof typeof NotificationsLogsGetStatusEnum];


/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Liste de tous les paiements
         * @param {PaymentsGetStatusEnum} [status] Filtrer par statut
         * @param {string} [rentalId] Filtrer par location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsGet: async (status?: PaymentsGetStatusEnum, rentalId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (rentalId !== undefined) {
                localVarQueryParameter['rental_id'] = rentalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Supprimer un paiement
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('paymentsIdDelete', 'id', id)
            const localVarPath = `/payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer un paiement par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('paymentsIdGet', 'id', id)
            const localVarPath = `/payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mettre à jour un paiement
         * @param {string} id 
         * @param {PaymentsIdPutRequest} paymentsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIdPut: async (id: string, paymentsIdPutRequest: PaymentsIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('paymentsIdPut', 'id', id)
            // verify required parameter 'paymentsIdPutRequest' is not null or undefined
            assertParamExists('paymentsIdPut', 'paymentsIdPutRequest', paymentsIdPutRequest)
            const localVarPath = `/payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentsIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Créer un nouveau paiement
         * @param {PaymentsPostRequest} paymentsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsPost: async (paymentsPostRequest: PaymentsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentsPostRequest' is not null or undefined
            assertParamExists('paymentsPost', 'paymentsPostRequest', paymentsPostRequest)
            const localVarPath = `/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Liste de tous les paiements
         * @param {PaymentsGetStatusEnum} [status] Filtrer par statut
         * @param {string} [rentalId] Filtrer par location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsGet(status?: PaymentsGetStatusEnum, rentalId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Payment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsGet(status, rentalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Supprimer un paiement
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupérer un paiement par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Payment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mettre à jour un paiement
         * @param {string} id 
         * @param {PaymentsIdPutRequest} paymentsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsIdPut(id: string, paymentsIdPutRequest: PaymentsIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Payment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsIdPut(id, paymentsIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Créer un nouveau paiement
         * @param {PaymentsPostRequest} paymentsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsPost(paymentsPostRequest: PaymentsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Payment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsPost(paymentsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Liste de tous les paiements
         * @param {PaymentsGetStatusEnum} [status] Filtrer par statut
         * @param {string} [rentalId] Filtrer par location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsGet(status?: PaymentsGetStatusEnum, rentalId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Payment>> {
            return localVarFp.paymentsGet(status, rentalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Supprimer un paiement
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer un paiement par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Payment> {
            return localVarFp.paymentsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mettre à jour un paiement
         * @param {string} id 
         * @param {PaymentsIdPutRequest} paymentsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIdPut(id: string, paymentsIdPutRequest: PaymentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Payment> {
            return localVarFp.paymentsIdPut(id, paymentsIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Créer un nouveau paiement
         * @param {PaymentsPostRequest} paymentsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsPost(paymentsPostRequest: PaymentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Payment> {
            return localVarFp.paymentsPost(paymentsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * 
     * @summary Liste de tous les paiements
     * @param {PaymentsGetStatusEnum} [status] Filtrer par statut
     * @param {string} [rentalId] Filtrer par location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsGet(status?: PaymentsGetStatusEnum, rentalId?: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsGet(status, rentalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Supprimer un paiement
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer un paiement par ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mettre à jour un paiement
     * @param {string} id 
     * @param {PaymentsIdPutRequest} paymentsIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsIdPut(id: string, paymentsIdPutRequest: PaymentsIdPutRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsIdPut(id, paymentsIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Créer un nouveau paiement
     * @param {PaymentsPostRequest} paymentsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsPost(paymentsPostRequest: PaymentsPostRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsPost(paymentsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const PaymentsGetStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Failed: 'failed',
    Refunded: 'refunded'
} as const;
export type PaymentsGetStatusEnum = typeof PaymentsGetStatusEnum[keyof typeof PaymentsGetStatusEnum];


/**
 * RecoveryApi - axios parameter creator
 * @export
 */
export const RecoveryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Envoie un code de réinitialisation à 6 chiffres (format XXX-XXX) par email. Le code est valide pendant 15 minutes. 
         * @summary Demander un code de réinitialisation de mot de passe
         * @param {ApiPasswordResetRequestPostRequest} apiPasswordResetRequestPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPasswordResetRequestPost: async (apiPasswordResetRequestPostRequest: ApiPasswordResetRequestPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiPasswordResetRequestPostRequest' is not null or undefined
            assertParamExists('apiPasswordResetRequestPost', 'apiPasswordResetRequestPostRequest', apiPasswordResetRequestPostRequest)
            const localVarPath = `/api/password-reset/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiPasswordResetRequestPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change le mot de passe de l\'utilisateur après vérification du code. Le code est automatiquement invalidé après utilisation. 
         * @summary Réinitialiser le mot de passe avec le code vérifié
         * @param {ApiPasswordResetResetPostRequest} apiPasswordResetResetPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPasswordResetResetPost: async (apiPasswordResetResetPostRequest: ApiPasswordResetResetPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiPasswordResetResetPostRequest' is not null or undefined
            assertParamExists('apiPasswordResetResetPost', 'apiPasswordResetResetPostRequest', apiPasswordResetResetPostRequest)
            const localVarPath = `/api/password-reset/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiPasswordResetResetPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vérifie le code de réinitialisation saisi par l\'utilisateur. Maximum 3 tentatives incorrectes autorisées. 
         * @summary Vérifier le code de réinitialisation
         * @param {ApiPasswordResetVerifyPostRequest} apiPasswordResetVerifyPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPasswordResetVerifyPost: async (apiPasswordResetVerifyPostRequest: ApiPasswordResetVerifyPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiPasswordResetVerifyPostRequest' is not null or undefined
            assertParamExists('apiPasswordResetVerifyPost', 'apiPasswordResetVerifyPostRequest', apiPasswordResetVerifyPostRequest)
            const localVarPath = `/api/password-reset/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiPasswordResetVerifyPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecoveryApi - functional programming interface
 * @export
 */
export const RecoveryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecoveryApiAxiosParamCreator(configuration)
    return {
        /**
         * Envoie un code de réinitialisation à 6 chiffres (format XXX-XXX) par email. Le code est valide pendant 15 minutes. 
         * @summary Demander un code de réinitialisation de mot de passe
         * @param {ApiPasswordResetRequestPostRequest} apiPasswordResetRequestPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPasswordResetRequestPost(apiPasswordResetRequestPostRequest: ApiPasswordResetRequestPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPasswordResetRequestPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPasswordResetRequestPost(apiPasswordResetRequestPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecoveryApi.apiPasswordResetRequestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change le mot de passe de l\'utilisateur après vérification du code. Le code est automatiquement invalidé après utilisation. 
         * @summary Réinitialiser le mot de passe avec le code vérifié
         * @param {ApiPasswordResetResetPostRequest} apiPasswordResetResetPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPasswordResetResetPost(apiPasswordResetResetPostRequest: ApiPasswordResetResetPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPasswordResetResetPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPasswordResetResetPost(apiPasswordResetResetPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecoveryApi.apiPasswordResetResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vérifie le code de réinitialisation saisi par l\'utilisateur. Maximum 3 tentatives incorrectes autorisées. 
         * @summary Vérifier le code de réinitialisation
         * @param {ApiPasswordResetVerifyPostRequest} apiPasswordResetVerifyPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPasswordResetVerifyPost(apiPasswordResetVerifyPostRequest: ApiPasswordResetVerifyPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPasswordResetVerifyPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPasswordResetVerifyPost(apiPasswordResetVerifyPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecoveryApi.apiPasswordResetVerifyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RecoveryApi - factory interface
 * @export
 */
export const RecoveryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecoveryApiFp(configuration)
    return {
        /**
         * Envoie un code de réinitialisation à 6 chiffres (format XXX-XXX) par email. Le code est valide pendant 15 minutes. 
         * @summary Demander un code de réinitialisation de mot de passe
         * @param {ApiPasswordResetRequestPostRequest} apiPasswordResetRequestPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPasswordResetRequestPost(apiPasswordResetRequestPostRequest: ApiPasswordResetRequestPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiPasswordResetRequestPost200Response> {
            return localVarFp.apiPasswordResetRequestPost(apiPasswordResetRequestPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Change le mot de passe de l\'utilisateur après vérification du code. Le code est automatiquement invalidé après utilisation. 
         * @summary Réinitialiser le mot de passe avec le code vérifié
         * @param {ApiPasswordResetResetPostRequest} apiPasswordResetResetPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPasswordResetResetPost(apiPasswordResetResetPostRequest: ApiPasswordResetResetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiPasswordResetResetPost200Response> {
            return localVarFp.apiPasswordResetResetPost(apiPasswordResetResetPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vérifie le code de réinitialisation saisi par l\'utilisateur. Maximum 3 tentatives incorrectes autorisées. 
         * @summary Vérifier le code de réinitialisation
         * @param {ApiPasswordResetVerifyPostRequest} apiPasswordResetVerifyPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPasswordResetVerifyPost(apiPasswordResetVerifyPostRequest: ApiPasswordResetVerifyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiPasswordResetVerifyPost200Response> {
            return localVarFp.apiPasswordResetVerifyPost(apiPasswordResetVerifyPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecoveryApi - object-oriented interface
 * @export
 * @class RecoveryApi
 * @extends {BaseAPI}
 */
export class RecoveryApi extends BaseAPI {
    /**
     * Envoie un code de réinitialisation à 6 chiffres (format XXX-XXX) par email. Le code est valide pendant 15 minutes. 
     * @summary Demander un code de réinitialisation de mot de passe
     * @param {ApiPasswordResetRequestPostRequest} apiPasswordResetRequestPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecoveryApi
     */
    public apiPasswordResetRequestPost(apiPasswordResetRequestPostRequest: ApiPasswordResetRequestPostRequest, options?: RawAxiosRequestConfig) {
        return RecoveryApiFp(this.configuration).apiPasswordResetRequestPost(apiPasswordResetRequestPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change le mot de passe de l\'utilisateur après vérification du code. Le code est automatiquement invalidé après utilisation. 
     * @summary Réinitialiser le mot de passe avec le code vérifié
     * @param {ApiPasswordResetResetPostRequest} apiPasswordResetResetPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecoveryApi
     */
    public apiPasswordResetResetPost(apiPasswordResetResetPostRequest: ApiPasswordResetResetPostRequest, options?: RawAxiosRequestConfig) {
        return RecoveryApiFp(this.configuration).apiPasswordResetResetPost(apiPasswordResetResetPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vérifie le code de réinitialisation saisi par l\'utilisateur. Maximum 3 tentatives incorrectes autorisées. 
     * @summary Vérifier le code de réinitialisation
     * @param {ApiPasswordResetVerifyPostRequest} apiPasswordResetVerifyPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecoveryApi
     */
    public apiPasswordResetVerifyPost(apiPasswordResetVerifyPostRequest: ApiPasswordResetVerifyPostRequest, options?: RawAxiosRequestConfig) {
        return RecoveryApiFp(this.configuration).apiPasswordResetVerifyPost(apiPasswordResetVerifyPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RentalsApi - axios parameter creator
 * @export
 */
export const RentalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupère le nombre de locations d\'un utilisateur (en tant que locataire ou propriétaire). Optimisé pour éviter de récupérer toutes les locations.  **Exemple d\'utilisation :** - `GET /api/rentals/count?renter_id=1f7b5873-51f5-4bf3-a5de-24abad8d4011` - Locations en tant que locataire - `GET /api/rentals/count?owner_id=1f7b5873-51f5-4bf3-a5de-24abad8d4011` - Locations en tant que propriétaire 
         * @summary Compter les locations d\'un utilisateur
         * @param {string} [renterId] ID de l\&#39;utilisateur locataire
         * @param {string} [ownerId] ID de l\&#39;utilisateur propriétaire
         * @param {ApiRentalsCountGetStatusEnum} [status] Filtrer par statut de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRentalsCountGet: async (renterId?: string, ownerId?: string, status?: ApiRentalsCountGetStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rentals/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (renterId !== undefined) {
                localVarQueryParameter['renter_id'] = renterId;
            }

            if (ownerId !== undefined) {
                localVarQueryParameter['owner_id'] = ownerId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Liste de toutes les locations
         * @param {ApiRentalsGetStatusEnum} [status] Filtrer par statut
         * @param {string} [renterId] Filtrer par locataire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRentalsGet: async (status?: ApiRentalsGetStatusEnum, renterId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rentals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (renterId !== undefined) {
                localVarQueryParameter['renter_id'] = renterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Supprimer une location
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRentalsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRentalsIdDelete', 'id', id)
            const localVarPath = `/api/rentals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer une location par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRentalsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRentalsIdGet', 'id', id)
            const localVarPath = `/api/rentals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mettre à jour une location
         * @param {string} id 
         * @param {ApiRentalsIdPutRequest} apiRentalsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRentalsIdPut: async (id: string, apiRentalsIdPutRequest: ApiRentalsIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRentalsIdPut', 'id', id)
            // verify required parameter 'apiRentalsIdPutRequest' is not null or undefined
            assertParamExists('apiRentalsIdPut', 'apiRentalsIdPutRequest', apiRentalsIdPutRequest)
            const localVarPath = `/api/rentals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiRentalsIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Créer une nouvelle location
         * @param {ApiRentalsPostRequest} apiRentalsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRentalsPost: async (apiRentalsPostRequest: ApiRentalsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiRentalsPostRequest' is not null or undefined
            assertParamExists('apiRentalsPost', 'apiRentalsPostRequest', apiRentalsPostRequest)
            const localVarPath = `/api/rentals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiRentalsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RentalsApi - functional programming interface
 * @export
 */
export const RentalsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RentalsApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupère le nombre de locations d\'un utilisateur (en tant que locataire ou propriétaire). Optimisé pour éviter de récupérer toutes les locations.  **Exemple d\'utilisation :** - `GET /api/rentals/count?renter_id=1f7b5873-51f5-4bf3-a5de-24abad8d4011` - Locations en tant que locataire - `GET /api/rentals/count?owner_id=1f7b5873-51f5-4bf3-a5de-24abad8d4011` - Locations en tant que propriétaire 
         * @summary Compter les locations d\'un utilisateur
         * @param {string} [renterId] ID de l\&#39;utilisateur locataire
         * @param {string} [ownerId] ID de l\&#39;utilisateur propriétaire
         * @param {ApiRentalsCountGetStatusEnum} [status] Filtrer par statut de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRentalsCountGet(renterId?: string, ownerId?: string, status?: ApiRentalsCountGetStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiRentalsCountGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRentalsCountGet(renterId, ownerId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RentalsApi.apiRentalsCountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Liste de toutes les locations
         * @param {ApiRentalsGetStatusEnum} [status] Filtrer par statut
         * @param {string} [renterId] Filtrer par locataire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRentalsGet(status?: ApiRentalsGetStatusEnum, renterId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Rental>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRentalsGet(status, renterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RentalsApi.apiRentalsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Supprimer une location
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRentalsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRentalsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RentalsApi.apiRentalsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupérer une location par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRentalsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rental>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRentalsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RentalsApi.apiRentalsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mettre à jour une location
         * @param {string} id 
         * @param {ApiRentalsIdPutRequest} apiRentalsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRentalsIdPut(id: string, apiRentalsIdPutRequest: ApiRentalsIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rental>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRentalsIdPut(id, apiRentalsIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RentalsApi.apiRentalsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Créer une nouvelle location
         * @param {ApiRentalsPostRequest} apiRentalsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRentalsPost(apiRentalsPostRequest: ApiRentalsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rental>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRentalsPost(apiRentalsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RentalsApi.apiRentalsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RentalsApi - factory interface
 * @export
 */
export const RentalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RentalsApiFp(configuration)
    return {
        /**
         * Récupère le nombre de locations d\'un utilisateur (en tant que locataire ou propriétaire). Optimisé pour éviter de récupérer toutes les locations.  **Exemple d\'utilisation :** - `GET /api/rentals/count?renter_id=1f7b5873-51f5-4bf3-a5de-24abad8d4011` - Locations en tant que locataire - `GET /api/rentals/count?owner_id=1f7b5873-51f5-4bf3-a5de-24abad8d4011` - Locations en tant que propriétaire 
         * @summary Compter les locations d\'un utilisateur
         * @param {string} [renterId] ID de l\&#39;utilisateur locataire
         * @param {string} [ownerId] ID de l\&#39;utilisateur propriétaire
         * @param {ApiRentalsCountGetStatusEnum} [status] Filtrer par statut de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRentalsCountGet(renterId?: string, ownerId?: string, status?: ApiRentalsCountGetStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<ApiRentalsCountGet200Response> {
            return localVarFp.apiRentalsCountGet(renterId, ownerId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Liste de toutes les locations
         * @param {ApiRentalsGetStatusEnum} [status] Filtrer par statut
         * @param {string} [renterId] Filtrer par locataire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRentalsGet(status?: ApiRentalsGetStatusEnum, renterId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Rental>> {
            return localVarFp.apiRentalsGet(status, renterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Supprimer une location
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRentalsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiRentalsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer une location par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRentalsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Rental> {
            return localVarFp.apiRentalsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mettre à jour une location
         * @param {string} id 
         * @param {ApiRentalsIdPutRequest} apiRentalsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRentalsIdPut(id: string, apiRentalsIdPutRequest: ApiRentalsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Rental> {
            return localVarFp.apiRentalsIdPut(id, apiRentalsIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Créer une nouvelle location
         * @param {ApiRentalsPostRequest} apiRentalsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRentalsPost(apiRentalsPostRequest: ApiRentalsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Rental> {
            return localVarFp.apiRentalsPost(apiRentalsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RentalsApi - object-oriented interface
 * @export
 * @class RentalsApi
 * @extends {BaseAPI}
 */
export class RentalsApi extends BaseAPI {
    /**
     * Récupère le nombre de locations d\'un utilisateur (en tant que locataire ou propriétaire). Optimisé pour éviter de récupérer toutes les locations.  **Exemple d\'utilisation :** - `GET /api/rentals/count?renter_id=1f7b5873-51f5-4bf3-a5de-24abad8d4011` - Locations en tant que locataire - `GET /api/rentals/count?owner_id=1f7b5873-51f5-4bf3-a5de-24abad8d4011` - Locations en tant que propriétaire 
     * @summary Compter les locations d\'un utilisateur
     * @param {string} [renterId] ID de l\&#39;utilisateur locataire
     * @param {string} [ownerId] ID de l\&#39;utilisateur propriétaire
     * @param {ApiRentalsCountGetStatusEnum} [status] Filtrer par statut de location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalsApi
     */
    public apiRentalsCountGet(renterId?: string, ownerId?: string, status?: ApiRentalsCountGetStatusEnum, options?: RawAxiosRequestConfig) {
        return RentalsApiFp(this.configuration).apiRentalsCountGet(renterId, ownerId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Liste de toutes les locations
     * @param {ApiRentalsGetStatusEnum} [status] Filtrer par statut
     * @param {string} [renterId] Filtrer par locataire
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalsApi
     */
    public apiRentalsGet(status?: ApiRentalsGetStatusEnum, renterId?: string, options?: RawAxiosRequestConfig) {
        return RentalsApiFp(this.configuration).apiRentalsGet(status, renterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Supprimer une location
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalsApi
     */
    public apiRentalsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return RentalsApiFp(this.configuration).apiRentalsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer une location par ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalsApi
     */
    public apiRentalsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return RentalsApiFp(this.configuration).apiRentalsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mettre à jour une location
     * @param {string} id 
     * @param {ApiRentalsIdPutRequest} apiRentalsIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalsApi
     */
    public apiRentalsIdPut(id: string, apiRentalsIdPutRequest: ApiRentalsIdPutRequest, options?: RawAxiosRequestConfig) {
        return RentalsApiFp(this.configuration).apiRentalsIdPut(id, apiRentalsIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Créer une nouvelle location
     * @param {ApiRentalsPostRequest} apiRentalsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalsApi
     */
    public apiRentalsPost(apiRentalsPostRequest: ApiRentalsPostRequest, options?: RawAxiosRequestConfig) {
        return RentalsApiFp(this.configuration).apiRentalsPost(apiRentalsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiRentalsCountGetStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;
export type ApiRentalsCountGetStatusEnum = typeof ApiRentalsCountGetStatusEnum[keyof typeof ApiRentalsCountGetStatusEnum];
/**
 * @export
 */
export const ApiRentalsGetStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;
export type ApiRentalsGetStatusEnum = typeof ApiRentalsGetStatusEnum[keyof typeof ApiRentalsGetStatusEnum];


/**
 * ReviewsApi - axios parameter creator
 * @export
 */
export const ReviewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Liste de tous les avis
         * @param {ReviewsGetReviewTypeEnum} [reviewType] Filtrer par type d\&#39;avis
         * @param {string} [reviewerId] Filtrer par évaluateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewsGet: async (reviewType?: ReviewsGetReviewTypeEnum, reviewerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reviewType !== undefined) {
                localVarQueryParameter['review_type'] = reviewType;
            }

            if (reviewerId !== undefined) {
                localVarQueryParameter['reviewer_id'] = reviewerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Supprimer un avis
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reviewsIdDelete', 'id', id)
            const localVarPath = `/reviews/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer un avis par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reviewsIdGet', 'id', id)
            const localVarPath = `/reviews/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mettre à jour un avis
         * @param {string} id 
         * @param {ReviewsIdPutRequest} reviewsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewsIdPut: async (id: string, reviewsIdPutRequest: ReviewsIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reviewsIdPut', 'id', id)
            // verify required parameter 'reviewsIdPutRequest' is not null or undefined
            assertParamExists('reviewsIdPut', 'reviewsIdPutRequest', reviewsIdPutRequest)
            const localVarPath = `/reviews/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewsIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Créer un nouvel avis
         * @param {ReviewsPostRequest} reviewsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewsPost: async (reviewsPostRequest: ReviewsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewsPostRequest' is not null or undefined
            assertParamExists('reviewsPost', 'reviewsPostRequest', reviewsPostRequest)
            const localVarPath = `/reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReviewsApi - functional programming interface
 * @export
 */
export const ReviewsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReviewsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Liste de tous les avis
         * @param {ReviewsGetReviewTypeEnum} [reviewType] Filtrer par type d\&#39;avis
         * @param {string} [reviewerId] Filtrer par évaluateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewsGet(reviewType?: ReviewsGetReviewTypeEnum, reviewerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Review>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewsGet(reviewType, reviewerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.reviewsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Supprimer un avis
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.reviewsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupérer un avis par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Review>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.reviewsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mettre à jour un avis
         * @param {string} id 
         * @param {ReviewsIdPutRequest} reviewsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewsIdPut(id: string, reviewsIdPutRequest: ReviewsIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Review>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewsIdPut(id, reviewsIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.reviewsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Créer un nouvel avis
         * @param {ReviewsPostRequest} reviewsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewsPost(reviewsPostRequest: ReviewsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Review>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewsPost(reviewsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.reviewsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReviewsApi - factory interface
 * @export
 */
export const ReviewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReviewsApiFp(configuration)
    return {
        /**
         * 
         * @summary Liste de tous les avis
         * @param {ReviewsGetReviewTypeEnum} [reviewType] Filtrer par type d\&#39;avis
         * @param {string} [reviewerId] Filtrer par évaluateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewsGet(reviewType?: ReviewsGetReviewTypeEnum, reviewerId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Review>> {
            return localVarFp.reviewsGet(reviewType, reviewerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Supprimer un avis
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reviewsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer un avis par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Review> {
            return localVarFp.reviewsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mettre à jour un avis
         * @param {string} id 
         * @param {ReviewsIdPutRequest} reviewsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewsIdPut(id: string, reviewsIdPutRequest: ReviewsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Review> {
            return localVarFp.reviewsIdPut(id, reviewsIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Créer un nouvel avis
         * @param {ReviewsPostRequest} reviewsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewsPost(reviewsPostRequest: ReviewsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Review> {
            return localVarFp.reviewsPost(reviewsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReviewsApi - object-oriented interface
 * @export
 * @class ReviewsApi
 * @extends {BaseAPI}
 */
export class ReviewsApi extends BaseAPI {
    /**
     * 
     * @summary Liste de tous les avis
     * @param {ReviewsGetReviewTypeEnum} [reviewType] Filtrer par type d\&#39;avis
     * @param {string} [reviewerId] Filtrer par évaluateur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public reviewsGet(reviewType?: ReviewsGetReviewTypeEnum, reviewerId?: string, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).reviewsGet(reviewType, reviewerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Supprimer un avis
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public reviewsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).reviewsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer un avis par ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public reviewsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).reviewsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mettre à jour un avis
     * @param {string} id 
     * @param {ReviewsIdPutRequest} reviewsIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public reviewsIdPut(id: string, reviewsIdPutRequest: ReviewsIdPutRequest, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).reviewsIdPut(id, reviewsIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Créer un nouvel avis
     * @param {ReviewsPostRequest} reviewsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public reviewsPost(reviewsPostRequest: ReviewsPostRequest, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).reviewsPost(reviewsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ReviewsGetReviewTypeEnum = {
    RenterToOwner: 'renter_to_owner',
    OwnerToRenter: 'owner_to_renter'
} as const;
export type ReviewsGetReviewTypeEnum = typeof ReviewsGetReviewTypeEnum[keyof typeof ReviewsGetReviewTypeEnum];


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Liste de tous les utilisateurs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changer le mot de passe d\'un utilisateur
         * @param {string} id 
         * @param {ApiUsersIdChangePasswordPostRequest} apiUsersIdChangePasswordPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdChangePasswordPost: async (id: string, apiUsersIdChangePasswordPostRequest: ApiUsersIdChangePasswordPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdChangePasswordPost', 'id', id)
            // verify required parameter 'apiUsersIdChangePasswordPostRequest' is not null or undefined
            assertParamExists('apiUsersIdChangePasswordPost', 'apiUsersIdChangePasswordPostRequest', apiUsersIdChangePasswordPostRequest)
            const localVarPath = `/api/users/{id}/change-password`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUsersIdChangePasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Supprimer un utilisateur
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdDelete', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer un utilisateur par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdGet', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mettre à jour un utilisateur
         * @param {string} id 
         * @param {ApiUsersIdPutRequest} apiUsersIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut: async (id: string, apiUsersIdPutRequest: ApiUsersIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdPut', 'id', id)
            // verify required parameter 'apiUsersIdPutRequest' is not null or undefined
            assertParamExists('apiUsersIdPut', 'apiUsersIdPutRequest', apiUsersIdPutRequest)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUsersIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Liste de tous les utilisateurs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Changer le mot de passe d\'un utilisateur
         * @param {string} id 
         * @param {ApiUsersIdChangePasswordPostRequest} apiUsersIdChangePasswordPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdChangePasswordPost(id: string, apiUsersIdChangePasswordPostRequest: ApiUsersIdChangePasswordPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUsersIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdChangePasswordPost(id, apiUsersIdChangePasswordPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdChangePasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Supprimer un utilisateur
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUsersIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupérer un utilisateur par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mettre à jour un utilisateur
         * @param {string} id 
         * @param {ApiUsersIdPutRequest} apiUsersIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdPut(id: string, apiUsersIdPutRequest: ApiUsersIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdPut(id, apiUsersIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Liste de tous les utilisateurs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<User>> {
            return localVarFp.apiUsersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changer le mot de passe d\'un utilisateur
         * @param {string} id 
         * @param {ApiUsersIdChangePasswordPostRequest} apiUsersIdChangePasswordPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdChangePasswordPost(id: string, apiUsersIdChangePasswordPostRequest: ApiUsersIdChangePasswordPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiUsersIdDelete200Response> {
            return localVarFp.apiUsersIdChangePasswordPost(id, apiUsersIdChangePasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Supprimer un utilisateur
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiUsersIdDelete200Response> {
            return localVarFp.apiUsersIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer un utilisateur par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.apiUsersIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mettre à jour un utilisateur
         * @param {string} id 
         * @param {ApiUsersIdPutRequest} apiUsersIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut(id: string, apiUsersIdPutRequest: ApiUsersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.apiUsersIdPut(id, apiUsersIdPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Liste de tous les utilisateurs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersGet(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changer le mot de passe d\'un utilisateur
     * @param {string} id 
     * @param {ApiUsersIdChangePasswordPostRequest} apiUsersIdChangePasswordPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersIdChangePasswordPost(id: string, apiUsersIdChangePasswordPostRequest: ApiUsersIdChangePasswordPostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdChangePasswordPost(id, apiUsersIdChangePasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Supprimer un utilisateur
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer un utilisateur par ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersIdGet(id: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mettre à jour un utilisateur
     * @param {string} id 
     * @param {ApiUsersIdPutRequest} apiUsersIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersIdPut(id: string, apiUsersIdPutRequest: ApiUsersIdPutRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdPut(id, apiUsersIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehiclesApi - axios parameter creator
 * @export
 */
export const VehiclesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupère le nombre de véhicules appartenant à un utilisateur. Optimisé pour éviter de récupérer tous les véhicules.  **Exemple d\'utilisation :** - `GET /api/vehicles/count?owner_id=1f7b5873-51f5-4bf3-a5de-24abad8d4011` 
         * @summary Compter les véhicules d\'un utilisateur
         * @param {string} ownerId ID de l\&#39;utilisateur propriétaire
         * @param {boolean} [available] Filtrer par disponibilité (true/false)
         * @param {ApiVehiclesCountGetTypeEnum} [type] Filtrer par type de véhicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesCountGet: async (ownerId: string, available?: boolean, type?: ApiVehiclesCountGetTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('apiVehiclesCountGet', 'ownerId', ownerId)
            const localVarPath = `/api/vehicles/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ownerId !== undefined) {
                localVarQueryParameter['owner_id'] = ownerId;
            }

            if (available !== undefined) {
                localVarQueryParameter['available'] = available;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupère la liste des véhicules avec possibilité de filtrage.  **Exemples d\'utilisation :** - `GET /api/vehicles` - Tous les véhicules - `GET /api/vehicles?owner_id=123` - Véhicules d\'un utilisateur spécifique - `GET /api/vehicles?available=true` - Véhicules disponibles - `GET /api/vehicles?type=scooter&available=true` - Scooters disponibles - `GET /api/vehicles?owner_id=123&available=true` - Véhicules disponibles d\'un utilisateur 
         * @summary Liste de tous les véhicules
         * @param {string} [ownerId] Filtrer par propriétaire (ID utilisateur). Exemple - &#x60;GET /api/vehicles?owner_id&#x3D;1f7b5873-51f5-4bf3-a5de-24abad8d4011&#x60;
         * @param {boolean} [available] Filtrer par disponibilité (true/false). Exemple - &#x60;GET /api/vehicles?available&#x3D;true&#x60;
         * @param {ApiVehiclesGetTypeEnum} [type] Filtrer par type de véhicule. Exemple - &#x60;GET /api/vehicles?type&#x3D;scooter&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesGet: async (ownerId?: string, available?: boolean, type?: ApiVehiclesGetTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/vehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ownerId !== undefined) {
                localVarQueryParameter['owner_id'] = ownerId;
            }

            if (available !== undefined) {
                localVarQueryParameter['available'] = available;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Supprimer un véhicule
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVehiclesIdDelete', 'id', id)
            const localVarPath = `/api/vehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer un véhicule par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVehiclesIdGet', 'id', id)
            const localVarPath = `/api/vehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mettre à jour un véhicule
         * @param {string} id 
         * @param {ApiVehiclesIdPutRequest} apiVehiclesIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesIdPut: async (id: string, apiVehiclesIdPutRequest: ApiVehiclesIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVehiclesIdPut', 'id', id)
            // verify required parameter 'apiVehiclesIdPutRequest' is not null or undefined
            assertParamExists('apiVehiclesIdPut', 'apiVehiclesIdPutRequest', apiVehiclesIdPutRequest)
            const localVarPath = `/api/vehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiVehiclesIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Créer un nouveau véhicule
         * @param {ApiVehiclesPostRequest} apiVehiclesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesPost: async (apiVehiclesPostRequest: ApiVehiclesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiVehiclesPostRequest' is not null or undefined
            assertParamExists('apiVehiclesPost', 'apiVehiclesPostRequest', apiVehiclesPostRequest)
            const localVarPath = `/api/vehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiVehiclesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehiclesApi - functional programming interface
 * @export
 */
export const VehiclesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehiclesApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupère le nombre de véhicules appartenant à un utilisateur. Optimisé pour éviter de récupérer tous les véhicules.  **Exemple d\'utilisation :** - `GET /api/vehicles/count?owner_id=1f7b5873-51f5-4bf3-a5de-24abad8d4011` 
         * @summary Compter les véhicules d\'un utilisateur
         * @param {string} ownerId ID de l\&#39;utilisateur propriétaire
         * @param {boolean} [available] Filtrer par disponibilité (true/false)
         * @param {ApiVehiclesCountGetTypeEnum} [type] Filtrer par type de véhicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVehiclesCountGet(ownerId: string, available?: boolean, type?: ApiVehiclesCountGetTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiVehiclesCountGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVehiclesCountGet(ownerId, available, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiVehiclesCountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupère la liste des véhicules avec possibilité de filtrage.  **Exemples d\'utilisation :** - `GET /api/vehicles` - Tous les véhicules - `GET /api/vehicles?owner_id=123` - Véhicules d\'un utilisateur spécifique - `GET /api/vehicles?available=true` - Véhicules disponibles - `GET /api/vehicles?type=scooter&available=true` - Scooters disponibles - `GET /api/vehicles?owner_id=123&available=true` - Véhicules disponibles d\'un utilisateur 
         * @summary Liste de tous les véhicules
         * @param {string} [ownerId] Filtrer par propriétaire (ID utilisateur). Exemple - &#x60;GET /api/vehicles?owner_id&#x3D;1f7b5873-51f5-4bf3-a5de-24abad8d4011&#x60;
         * @param {boolean} [available] Filtrer par disponibilité (true/false). Exemple - &#x60;GET /api/vehicles?available&#x3D;true&#x60;
         * @param {ApiVehiclesGetTypeEnum} [type] Filtrer par type de véhicule. Exemple - &#x60;GET /api/vehicles?type&#x3D;scooter&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVehiclesGet(ownerId?: string, available?: boolean, type?: ApiVehiclesGetTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Vehicle>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVehiclesGet(ownerId, available, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiVehiclesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Supprimer un véhicule
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVehiclesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVehiclesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiVehiclesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupérer un véhicule par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVehiclesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVehiclesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiVehiclesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mettre à jour un véhicule
         * @param {string} id 
         * @param {ApiVehiclesIdPutRequest} apiVehiclesIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVehiclesIdPut(id: string, apiVehiclesIdPutRequest: ApiVehiclesIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVehiclesIdPut(id, apiVehiclesIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiVehiclesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Créer un nouveau véhicule
         * @param {ApiVehiclesPostRequest} apiVehiclesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVehiclesPost(apiVehiclesPostRequest: ApiVehiclesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVehiclesPost(apiVehiclesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiVehiclesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehiclesApi - factory interface
 * @export
 */
export const VehiclesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehiclesApiFp(configuration)
    return {
        /**
         * Récupère le nombre de véhicules appartenant à un utilisateur. Optimisé pour éviter de récupérer tous les véhicules.  **Exemple d\'utilisation :** - `GET /api/vehicles/count?owner_id=1f7b5873-51f5-4bf3-a5de-24abad8d4011` 
         * @summary Compter les véhicules d\'un utilisateur
         * @param {string} ownerId ID de l\&#39;utilisateur propriétaire
         * @param {boolean} [available] Filtrer par disponibilité (true/false)
         * @param {ApiVehiclesCountGetTypeEnum} [type] Filtrer par type de véhicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesCountGet(ownerId: string, available?: boolean, type?: ApiVehiclesCountGetTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<ApiVehiclesCountGet200Response> {
            return localVarFp.apiVehiclesCountGet(ownerId, available, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupère la liste des véhicules avec possibilité de filtrage.  **Exemples d\'utilisation :** - `GET /api/vehicles` - Tous les véhicules - `GET /api/vehicles?owner_id=123` - Véhicules d\'un utilisateur spécifique - `GET /api/vehicles?available=true` - Véhicules disponibles - `GET /api/vehicles?type=scooter&available=true` - Scooters disponibles - `GET /api/vehicles?owner_id=123&available=true` - Véhicules disponibles d\'un utilisateur 
         * @summary Liste de tous les véhicules
         * @param {string} [ownerId] Filtrer par propriétaire (ID utilisateur). Exemple - &#x60;GET /api/vehicles?owner_id&#x3D;1f7b5873-51f5-4bf3-a5de-24abad8d4011&#x60;
         * @param {boolean} [available] Filtrer par disponibilité (true/false). Exemple - &#x60;GET /api/vehicles?available&#x3D;true&#x60;
         * @param {ApiVehiclesGetTypeEnum} [type] Filtrer par type de véhicule. Exemple - &#x60;GET /api/vehicles?type&#x3D;scooter&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesGet(ownerId?: string, available?: boolean, type?: ApiVehiclesGetTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<Vehicle>> {
            return localVarFp.apiVehiclesGet(ownerId, available, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Supprimer un véhicule
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiVehiclesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer un véhicule par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Vehicle> {
            return localVarFp.apiVehiclesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mettre à jour un véhicule
         * @param {string} id 
         * @param {ApiVehiclesIdPutRequest} apiVehiclesIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesIdPut(id: string, apiVehiclesIdPutRequest: ApiVehiclesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Vehicle> {
            return localVarFp.apiVehiclesIdPut(id, apiVehiclesIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Créer un nouveau véhicule
         * @param {ApiVehiclesPostRequest} apiVehiclesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesPost(apiVehiclesPostRequest: ApiVehiclesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Vehicle> {
            return localVarFp.apiVehiclesPost(apiVehiclesPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehiclesApi - object-oriented interface
 * @export
 * @class VehiclesApi
 * @extends {BaseAPI}
 */
export class VehiclesApi extends BaseAPI {
    /**
     * Récupère le nombre de véhicules appartenant à un utilisateur. Optimisé pour éviter de récupérer tous les véhicules.  **Exemple d\'utilisation :** - `GET /api/vehicles/count?owner_id=1f7b5873-51f5-4bf3-a5de-24abad8d4011` 
     * @summary Compter les véhicules d\'un utilisateur
     * @param {string} ownerId ID de l\&#39;utilisateur propriétaire
     * @param {boolean} [available] Filtrer par disponibilité (true/false)
     * @param {ApiVehiclesCountGetTypeEnum} [type] Filtrer par type de véhicule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiVehiclesCountGet(ownerId: string, available?: boolean, type?: ApiVehiclesCountGetTypeEnum, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiVehiclesCountGet(ownerId, available, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupère la liste des véhicules avec possibilité de filtrage.  **Exemples d\'utilisation :** - `GET /api/vehicles` - Tous les véhicules - `GET /api/vehicles?owner_id=123` - Véhicules d\'un utilisateur spécifique - `GET /api/vehicles?available=true` - Véhicules disponibles - `GET /api/vehicles?type=scooter&available=true` - Scooters disponibles - `GET /api/vehicles?owner_id=123&available=true` - Véhicules disponibles d\'un utilisateur 
     * @summary Liste de tous les véhicules
     * @param {string} [ownerId] Filtrer par propriétaire (ID utilisateur). Exemple - &#x60;GET /api/vehicles?owner_id&#x3D;1f7b5873-51f5-4bf3-a5de-24abad8d4011&#x60;
     * @param {boolean} [available] Filtrer par disponibilité (true/false). Exemple - &#x60;GET /api/vehicles?available&#x3D;true&#x60;
     * @param {ApiVehiclesGetTypeEnum} [type] Filtrer par type de véhicule. Exemple - &#x60;GET /api/vehicles?type&#x3D;scooter&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiVehiclesGet(ownerId?: string, available?: boolean, type?: ApiVehiclesGetTypeEnum, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiVehiclesGet(ownerId, available, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Supprimer un véhicule
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiVehiclesIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiVehiclesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer un véhicule par ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiVehiclesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiVehiclesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mettre à jour un véhicule
     * @param {string} id 
     * @param {ApiVehiclesIdPutRequest} apiVehiclesIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiVehiclesIdPut(id: string, apiVehiclesIdPutRequest: ApiVehiclesIdPutRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiVehiclesIdPut(id, apiVehiclesIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Créer un nouveau véhicule
     * @param {ApiVehiclesPostRequest} apiVehiclesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiVehiclesPost(apiVehiclesPostRequest: ApiVehiclesPostRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiVehiclesPost(apiVehiclesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiVehiclesCountGetTypeEnum = {
    Scooter: 'scooter',
    Bike: 'bike',
    Car: 'car',
    Motorcycle: 'motorcycle'
} as const;
export type ApiVehiclesCountGetTypeEnum = typeof ApiVehiclesCountGetTypeEnum[keyof typeof ApiVehiclesCountGetTypeEnum];
/**
 * @export
 */
export const ApiVehiclesGetTypeEnum = {
    Scooter: 'scooter',
    Bike: 'bike',
    Car: 'car',
    Motorcycle: 'motorcycle'
} as const;
export type ApiVehiclesGetTypeEnum = typeof ApiVehiclesGetTypeEnum[keyof typeof ApiVehiclesGetTypeEnum];


/**
 * VrificationsApi - axios parameter creator
 * @export
 */
export const VrificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Liste de toutes les vérifications
         * @param {string} [userId] Filtrer par utilisateur
         * @param {VerificationsGetVerificationTypeEnum} [verificationType] Filtrer par type de vérification
         * @param {VerificationsGetStatusEnum} [status] Filtrer par statut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificationsGet: async (userId?: string, verificationType?: VerificationsGetVerificationTypeEnum, status?: VerificationsGetStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/verifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (verificationType !== undefined) {
                localVarQueryParameter['verification_type'] = verificationType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Supprimer une vérification par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificationsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('verificationsIdDelete', 'id', id)
            const localVarPath = `/verifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer une vérification par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificationsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('verificationsIdGet', 'id', id)
            const localVarPath = `/verifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mettre à jour une vérification
         * @param {string} id 
         * @param {VerificationsIdPutRequest} verificationsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificationsIdPut: async (id: string, verificationsIdPutRequest: VerificationsIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('verificationsIdPut', 'id', id)
            // verify required parameter 'verificationsIdPutRequest' is not null or undefined
            assertParamExists('verificationsIdPut', 'verificationsIdPutRequest', verificationsIdPutRequest)
            const localVarPath = `/verifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificationsIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Créer une nouvelle vérification
         * @param {VerificationsPostRequest} verificationsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificationsPost: async (verificationsPostRequest: VerificationsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verificationsPostRequest' is not null or undefined
            assertParamExists('verificationsPost', 'verificationsPostRequest', verificationsPostRequest)
            const localVarPath = `/verifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificationsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VrificationsApi - functional programming interface
 * @export
 */
export const VrificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VrificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Liste de toutes les vérifications
         * @param {string} [userId] Filtrer par utilisateur
         * @param {VerificationsGetVerificationTypeEnum} [verificationType] Filtrer par type de vérification
         * @param {VerificationsGetStatusEnum} [status] Filtrer par statut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verificationsGet(userId?: string, verificationType?: VerificationsGetVerificationTypeEnum, status?: VerificationsGetStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Verification>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verificationsGet(userId, verificationType, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VrificationsApi.verificationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Supprimer une vérification par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verificationsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verificationsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VrificationsApi.verificationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Récupérer une vérification par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verificationsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Verification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verificationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VrificationsApi.verificationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mettre à jour une vérification
         * @param {string} id 
         * @param {VerificationsIdPutRequest} verificationsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verificationsIdPut(id: string, verificationsIdPutRequest: VerificationsIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Verification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verificationsIdPut(id, verificationsIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VrificationsApi.verificationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Créer une nouvelle vérification
         * @param {VerificationsPostRequest} verificationsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verificationsPost(verificationsPostRequest: VerificationsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Verification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verificationsPost(verificationsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VrificationsApi.verificationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VrificationsApi - factory interface
 * @export
 */
export const VrificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VrificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Liste de toutes les vérifications
         * @param {string} [userId] Filtrer par utilisateur
         * @param {VerificationsGetVerificationTypeEnum} [verificationType] Filtrer par type de vérification
         * @param {VerificationsGetStatusEnum} [status] Filtrer par statut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificationsGet(userId?: string, verificationType?: VerificationsGetVerificationTypeEnum, status?: VerificationsGetStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<Verification>> {
            return localVarFp.verificationsGet(userId, verificationType, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Supprimer une vérification par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificationsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.verificationsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer une vérification par ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificationsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Verification> {
            return localVarFp.verificationsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mettre à jour une vérification
         * @param {string} id 
         * @param {VerificationsIdPutRequest} verificationsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificationsIdPut(id: string, verificationsIdPutRequest: VerificationsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Verification> {
            return localVarFp.verificationsIdPut(id, verificationsIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Créer une nouvelle vérification
         * @param {VerificationsPostRequest} verificationsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verificationsPost(verificationsPostRequest: VerificationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Verification> {
            return localVarFp.verificationsPost(verificationsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VrificationsApi - object-oriented interface
 * @export
 * @class VrificationsApi
 * @extends {BaseAPI}
 */
export class VrificationsApi extends BaseAPI {
    /**
     * 
     * @summary Liste de toutes les vérifications
     * @param {string} [userId] Filtrer par utilisateur
     * @param {VerificationsGetVerificationTypeEnum} [verificationType] Filtrer par type de vérification
     * @param {VerificationsGetStatusEnum} [status] Filtrer par statut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VrificationsApi
     */
    public verificationsGet(userId?: string, verificationType?: VerificationsGetVerificationTypeEnum, status?: VerificationsGetStatusEnum, options?: RawAxiosRequestConfig) {
        return VrificationsApiFp(this.configuration).verificationsGet(userId, verificationType, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Supprimer une vérification par ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VrificationsApi
     */
    public verificationsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return VrificationsApiFp(this.configuration).verificationsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer une vérification par ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VrificationsApi
     */
    public verificationsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return VrificationsApiFp(this.configuration).verificationsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mettre à jour une vérification
     * @param {string} id 
     * @param {VerificationsIdPutRequest} verificationsIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VrificationsApi
     */
    public verificationsIdPut(id: string, verificationsIdPutRequest: VerificationsIdPutRequest, options?: RawAxiosRequestConfig) {
        return VrificationsApiFp(this.configuration).verificationsIdPut(id, verificationsIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Créer une nouvelle vérification
     * @param {VerificationsPostRequest} verificationsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VrificationsApi
     */
    public verificationsPost(verificationsPostRequest: VerificationsPostRequest, options?: RawAxiosRequestConfig) {
        return VrificationsApiFp(this.configuration).verificationsPost(verificationsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const VerificationsGetVerificationTypeEnum = {
    Identity: 'identity',
    License: 'license',
    VehicleOwnership: 'vehicle_ownership',
    Insurance: 'insurance'
} as const;
export type VerificationsGetVerificationTypeEnum = typeof VerificationsGetVerificationTypeEnum[keyof typeof VerificationsGetVerificationTypeEnum];
/**
 * @export
 */
export const VerificationsGetStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;
export type VerificationsGetStatusEnum = typeof VerificationsGetStatusEnum[keyof typeof VerificationsGetStatusEnum];


